<template>
  <div>


    <b-card no-body>
      <b-card-body class="px-1 pt-1 pb-0">
        <b-row>
          <!-- Per Page -->

          <b-col
              xl="2"
              md="9"
              sm="6"
              style="display: none"
          >
            <b-form-group>
              <label>Fecha Corte</label>
              <flat-pickr
                  id="idfechac"
                  v-model="fechaCorteSelect"
                  class="form-control"
                  style="height: 30px"
                  :config="{
                    dateFormat: 'd/m/Y',
                    defaultDate: [new Date()],
                    locale: 'es',
                     maxDate: new Date(),

                  }"

              />
            </b-form-group>
          </b-col>
          <b-col
              xl="2"
              md="9"
              sm="6"
          >
            <b-form-group
                label="Rango Fecha Tareo"
                label-for="rangeFechaFil"
            >
              <flat-pickr
                  id="rangeFechaFil"
                  v-model="rangeDateFil"
                  class="form-control"
                  :config="{
                    mode: 'range',
                    dateFormat: 'd/m/Y',
                    locale: 'es',

                  }"
                  style="height: 31px"

              />
            </b-form-group>
          </b-col>

          <b-col
              xl="2"
              md="9"
              sm="6"
              class="mb-sm-1"
          >
            <b-form-group
                label="Último día asistencia"
                label-for="condicion"
            >
              <b-form-input
                  id="ultimo_dia_asistencia"
                  placeholder="Último día asistencia"
                  v-model="ultimoDiaAsistencia"
                  type="number"
                  style="height: 31px"
                  disabled=""
              />
            </b-form-group>

          </b-col>
          <b-col
              xl="2"
              md="9"
              sm="6"
              class="mb-sm-1"
          >
            <b-form-group
                label="Condición"
                label-for="condicion"
            >
              <b-form-input
                  id="condicion"
                  placeholder="Condición"
                  v-model="condicion"
                  type="number"
                  style="height: 31px"
              />
            </b-form-group>

          </b-col>

          <b-col
              xl="3"
              md="9"
              sm="6"
              class="mb-md-0 mb-2"
          >
            <b-form-group
                label=""
                label-for="id_cultivo"
            >
              <label>&nbsp;</label>
              <br>
              <b-button
                  variant="gradient-warning"
                  size="sm"
                  @click="validadEntradaRangeFiltro('2','LF')"
              >
                <feather-icon
                    icon="PlusIcon"
                    class="mr-50"
                />
                <span class="align-middle">Actualizar datos tabla</span>
              </b-button>
            </b-form-group>

          </b-col>
          <b-col
              xl="2"
              md="9"
              sm="6"
              class="mb-md-0 mb-2"
          >
            <b-form-group
                label=""
                label-for="id_cultivo"
            >
              <label>&nbsp;</label>
              <br>
              <b-button
                  variant="gradient-danger"
                  size="sm"
                  @click="descargarFile"
              >

                <feather-icon
                    :icon="`${loading_exp ? 'RefreshCwIcon' : 'FileTextIcon'}`"
                    :class="`${loading_exp ? 'spinner' : ''}`"
                />
                <span class="align-middle" v-if="loading_exp">Generando Excel</span>
                <span class="align-middle" v-else> Exportar</span>

              </b-button>
            </b-form-group>

          </b-col>
          <!-- Search -->
        </b-row>
      </b-card-body>
    </b-card>
    <b-card no-body>
      <b-card-body class="px-1 pt-1 pb-0">
        <b-row>
          <b-col
              xl="2"
              md="9"
              sm="6"
              class="mb-sm-1"
          >
            <b-form-group
                label="Estado cosecha"
                label-for="id_cultivo"
            >
              <v-select
                  id="estado_f"
                  v-model="estadoCosechaSelected"
                  :options="estadoCosecha"
                  :reduce="estadoCosecha => estadoCosecha.value"
                  label="text"
                  key="value"
                  placeholder="Seleccionar estado cosecha..."
                  class="select-size-sm"
              />
            </b-form-group>

          </b-col>
          <b-col
              xl="4"
              md="9"
              sm="6"
              class="mb-sm-1"
          >
            <b-form-group
                label="Categoría"
                label-for="id_cultivo"
            >
              <v-select
                  id="idcategoria"
                  v-model="categoriaSelected"
                  :options="optcategoria"
                  :reduce="optcategoria => optcategoria.value"
                  label="text"
                  multiple
                  key="value"
                  placeholder="Seleccionar categoría..."
                  @input="myFunc"
                  class="select-size-sm"
              />
            </b-form-group>

          </b-col>

          <b-col
              xl="2"
              md="9"
              sm="6"
              class="mb-sm-1"
          >
            <b-form-group
                label="Regla cumplimiento"
                label-for="idoperador"
            >
              <v-select
                  id="idoperador"
                  v-model="operadorSelected"
                  :options="optOperador"
                  :reduce="optOperador => optOperador.value"
                  label="text"
                  key="value"
                  placeholder="Seleccionar ..."
                  class="select-size-sm"
              />
            </b-form-group>

          </b-col>
          <b-col
              xl="2"
              md="9"
              sm="6"
              class="mb-sm-1"
          >
            <b-form-group
                label="% Cumplimiento"
                label-for="cumplimiento"
            >
              <b-form-input
                  id="cumplimiento"
                  placeholder="% cumplimiento"
                  v-model="cumplimientoText"
                  type="number"
                  style="height: 31px"
              />
            </b-form-group>

          </b-col>
          <b-col
              xl="2"
              md="9"
              sm="6"
              class="mb-md-0 mb-2"
          >
            <b-form-group
                label=""
                label-for="id_cultivo"
            >
              <label>&nbsp;</label>
              <br>
              <b-button
                  variant="gradient-primary"
                  size="sm"
                  @click="realizarFiltroCabeceraTable('filtra_t', ['filtra_t'],'filtra_t')"
              >
                <feather-icon
                    icon="PlusIcon"
                    class="mr-50"
                />
                <span class="align-middle">Filtrar tabla</span>
              </b-button>
            </b-form-group>

          </b-col>

          <!-- Search -->
        </b-row>

      </b-card-body>
    </b-card>
    <b-card no-body >

      <b-card-body class="px-1 pt-1 pb-1" >

        <div >
          <b-row>
            <!-- Per Page -->
            <b-col
                xl="4"
                md="3"
                sm="6"
                class="mb-sm-1"
            >
              <b-form-group
                  label-for="filterInput"
                  class="mb-0"
              >

                <b-button
                    variant="gradient-success"
                    size="sm"
                    @click="validadEntradaRangeFiltro('2','LF')"
                    :disabled="loading"
                >

                  <span v-if="loading"><b-spinner style="width: 16px; height: 16px;" /></span>
                  <feather-icon v-else icon="RefreshCwIcon" />
                  <span class="align-middle"> &nbsp;</span>

                </b-button>

                <b-button
                    variant="gradient-primary"
                    size="sm"
                    @click="DarDeBaja"
                >
                  <feather-icon
                      icon="ArrowDownCircleIcon"
                      class="mr-50"
                  />
                  <span class="align-middle">Dar de Baja</span>
                </b-button>
                <div v-if="show" class="spinner-border text-success" role="status"
                     style="width: 1.3rem; height: 1.3rem; position: relative;top: 11px"
                >
                </div>
              </b-form-group>
            </b-col>
            <b-col
                xl="3"
                md="9"
                sm="6"
            >
              <b-form-group
                  label-for="filterInput"
                  class="mb-0"
              >

                <b-button
                    variant="gradient-secondary"
                    size="sm"
                    @click="validadEntradaRangeFiltro('2','RF')"
                >
                  <feather-icon
                      icon="TargetIcon"
                      class="mr-50"
                  />
                  <span class="align-middle">Resumen categoría</span>
                </b-button>

              </b-form-group>

            </b-col>
            <b-col
                xl="2"
                md="9"
                sm="6"
            >

            </b-col>


            <!-- Search -->
            <b-col
                xl="3"
                md="3"
                sm="6"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-input-group size="sm">
                  <b-form-input
                      id="filterInput"
                      v-model="filterTable"
                      type="search"
                      placeholder="Buscar"
                      :disabled="loading"
                      @input="filtros2"
                      size="sm"
                  />
                </b-input-group>
              </div>
            </b-col>
          </b-row>
        </div>

        <div>
          <vue-good-table
              @on-selected-rows-change="selectionChanged"
              :columns="columns"
              id="my-table"
              ref="my-table"
              :rows="rowsBajaProductividadFiltro"
              :rtl="direction"
              :isLoading="loading"
              :select-options="{
              enabled: true,
              selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
              selectionInfoClass: 'custom-class',
              selectionText: 'rows selected',
              clearSelectionText: 'clear',
              disableSelectInfo: true, // disable the select info panel on top
              selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
            }"
              :pagination-options="{
              enabled: true,
              perPage:pageLength,
              //mode: 'records'
            }"
              :sort-options="{
              enabled: true,
              initialSortBy: {field: sortByTable, type: sortAscDesc}
            }"
              :styleClass=  "isThema?isThemaPage_dia:isThemaPage_noche"

          >

            <!--
                          max-height="700px"

             styleClass=  "vgt-table bordered"
             @on-row-dblclick="onRowDoubleClick"
              @on-row-click="onRowClick"
              @on-page-change="onPageChange"
            -->
            <template slot="table-column" slot-scope="props">

              <span v-if="props.column.field === 'nombre_empresa'">
                <div class="text-nowrap">
                  <b-dropdown
                      menu-class=""
                      size="sm"
                      variant="btn"
                      :toggle-class="`${empresaFiltroCabeceraTableSelected.length>0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                      :style="`${empresaFiltroCabeceraTableSelected.length>0 ? 'text-decoration: underline #fba820e6;' : ''}`"
                      block
                  >
                  <template #button-content class="text-danger">
                  <b >Empresa <feather-icon class="float-right" icon="FilterIcon" /></b>

                </template>
                  <b-dropdown-form >
                  <b-form-group label="Filtrar Empresa" label-for="empresaFiltroCabeceraTableSelected" @click.prevent class="py-0 my-0">
                  <v-select
                      id="empresaFiltroCabeceraTableSelected"
                      v-model="empresaFiltroCabeceraTableSelected"
                      :options="empresaFiltroCabeceraTableOpciones"
                      multiple
                      placeholder="Seleccionar ..."
                      class="select-size-sm"
                      @input="realizarFiltroCabeceraTable('nombre_empresa', empresaFiltroCabeceraTableSelected,'=')"
                  />
                </b-form-group>
                </b-dropdown-form>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('nombre_empresa', 'acs')">
                  <feather-icon class="mr-1" icon="ArrowDownIcon" />
                  <span class="align-middle ml-50">Ordenar Ascendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('nombre_empresa', 'desc')">
                  <feather-icon class="mr-1" icon="ArrowUpIcon" />
                  <span class="align-middle ml-50">Ordenar Descendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="cancelarOrdenacionCabeceraTable('nombre_empresa')">
                  <feather-icon class="mr-1" icon="RotateCcwIcon" />
                  <span class="align-middle ml-50">Cancelar Ordenación</span>
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>

                <b-dropdown-item @click="empresaFiltroCabeceraTableSelected=[]; realizarFiltroCabeceraTable('nombre_empresa', [],'=')">
                  <feather-icon class="mr-1" icon="DeleteIcon" />
                  <span class="align-middle ml-50">Borrar Filtro</span>
                  </b-dropdown-item>
                  </b-dropdown>
                </div>

              </span>
              <span v-else-if="props.column.field === 'dni_trabajador'">
                <div class="text-nowrap">
                  <b-dropdown
                      menu-class=""
                      size="sm"
                      variant="btn"
                      :toggle-class="`${dniTrabajadorFiltroCabeceraTableSelected.length>0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                      :style="`${dniTrabajadorFiltroCabeceraTableSelected.length>0 ? 'text-decoration: underline #fba820e6;' : ''}`"
                      block
                  >
                  <template #button-content class="text-danger">
                  <b >DNI <feather-icon class="float-right" icon="FilterIcon" /></b>

                </template>
                  <b-dropdown-form >
                  <b-form-group label="Filtrar Dni" label-for="dniTrabajadorFiltroCabeceraTableSelected" @click.prevent class="py-0 my-0">
                  <v-select
                      id="dniTrabajadorFiltroCabeceraTableSelected"
                      v-model="dniTrabajadorFiltroCabeceraTableSelected"
                      :options="dniTrabajadorFiltroCabeceraTableOpciones"
                      multiple
                      placeholder="Seleccionar ..."
                      class="select-size-sm"
                      @input="realizarFiltroCabeceraTable('dni_trabajador', dniTrabajadorFiltroCabeceraTableSelected,'=')"
                  />
                </b-form-group>
                </b-dropdown-form>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('dni_trabajador', 'acs')">
                  <feather-icon class="mr-1" icon="ArrowDownIcon" />
                  <span class="align-middle ml-50">Ordenar Ascendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('dni_trabajador', 'desc')">
                  <feather-icon class="mr-1" icon="ArrowUpIcon" />
                  <span class="align-middle ml-50">Ordenar Descendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="cancelarOrdenacionCabeceraTable('dni_trabajador')">
                  <feather-icon class="mr-1" icon="RotateCcwIcon" />
                  <span class="align-middle ml-50">Cancelar Ordenación</span>
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>

                <b-dropdown-item @click="dniTrabajadorFiltroCabeceraTableSelected=[]; realizarFiltroCabeceraTable('dni_trabajador', [],'=')">
                  <feather-icon class="mr-1" icon="DeleteIcon" />
                  <span class="align-middle ml-50">Borrar Filtro</span>
                  </b-dropdown-item>
                  </b-dropdown>
                </div>

              </span>
              <span v-else-if="props.column.field === 'nombres_trabajador'">
                <div class="text-nowrap">
                <b-dropdown
                    menu-class=""
                    size="sm"
                    variant="btn"
                    :toggle-class="`${trabajadorFiltroCabeceraTableSelected.length>0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                    :style="`${trabajadorFiltroCabeceraTableSelected.length>0 ? 'text-decoration: underline #fba820e6;' : ''}`"
                    block
                >
                  <template #button-content class="text-danger">
                  <b >NOMBRE TRABAJADOR <feather-icon class="float-right" icon="FilterIcon" /></b>

                </template>
                  <b-dropdown-form >
                  <b-form-group label="Filtrar trabajador" label-for="trabajadorFiltroCabeceraTableSelected" @click.prevent class="py-0 my-0">
                  <v-select
                      id="trabajadorFiltroCabeceraTableSelected"
                      v-model="trabajadorFiltroCabeceraTableSelected"
                      :options="trabajadorFiltroCabeceraTableOpciones"
                      multiple
                      placeholder="Seleccionar trabajador ..."
                      class="select-size-sm"
                      @input="realizarFiltroCabeceraTable('nombres_trabajador', trabajadorFiltroCabeceraTableSelected,'=')"
                  />
                </b-form-group>
                </b-dropdown-form>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('nombres_trabajador', 'acs')">
                  <feather-icon class="mr-1" icon="ArrowDownIcon" />
                  <span class="align-middle ml-50">Ordenar Ascendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('nombres_trabajador', 'desc')">
                  <feather-icon class="mr-1" icon="ArrowUpIcon" />
                  <span class="align-middle ml-50">Ordenar Descendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="cancelarOrdenacionCabeceraTable('nombres_trabajador')">
                  <feather-icon class="mr-1" icon="RotateCcwIcon" />
                  <span class="align-middle ml-50">Cancelar Ordenación</span>
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>

                <b-dropdown-item @click="trabajadorFiltroCabeceraTableSelected=[]; realizarFiltroCabeceraTable('nombres_trabajador', [],'=')">
                  <feather-icon class="mr-1" icon="DeleteIcon" />
                  <span class="align-middle ml-50">Borrar Filtro</span>
                </b-dropdown-item>
              </b-dropdown>
              </div>
              </span>
              <span v-else-if="props.column.field === 'fecha_penultima_contrato'">
                <div class="text-nowrap">
                <b-dropdown
                    menu-class=""
                    size="sm"
                    variant="btn"
                    :toggle-class="`${fechaUlIngresoFiltroCabeceraTableSelected.length>0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                    :style="`${fechaUlIngresoFiltroCabeceraTableSelected.length>0 ? 'text-decoration: underline #fba820e6;' : ''}`"
                    block
                >
                  <template #button-content class="text-danger">
                  <b >FECHA INGRESO <feather-icon class="float-right" icon="FilterIcon" /></b>

                </template>
                  <b-dropdown-form >
                  <b-form-group label="Filtrar Reingreso" label-for="fechReingresoFiltroCabeceraTableSelected" @click.prevent class="py-0 my-0">
                  <v-select
                      id="fechUlIngresoFiltroCabeceraTableSelected"
                      v-model="fechaUlIngresoFiltroCabeceraTableSelected"
                      :options="fechaUlIngresoFiltroCabeceraTableOpciones"
                      placeholder="Seleccionar ingreso ..."
                      multiple
                      class="select-size-sm"
                      @input="realizarFiltroCabeceraTable('fecha_penultima_contrato', fechaUlIngresoFiltroCabeceraTableSelected,'=')"
                  />
                </b-form-group>
                </b-dropdown-form>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('fecha_penultima_contrato', 'acs')">
                  <feather-icon class="mr-1" icon="ArrowDownIcon" />
                  <span class="align-middle ml-50">Ordenar Ascendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('fecha_penultima_contrato', 'desc')">
                  <feather-icon class="mr-1" icon="ArrowUpIcon" />
                  <span class="align-middle ml-50">Ordenar Descendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="cancelarOrdenacionCabeceraTable('fecha_penultima_contrato')">
                  <feather-icon class="mr-1" icon="RotateCcwIcon" />
                  <span class="align-middle ml-50">Cancelar Ordenación</span>
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>

                <b-dropdown-item @click="fechaUlIngresoFiltroCabeceraTableSelected=[]; realizarFiltroCabeceraTable('fecha_penultima_contrato', [],'=')">
                  <feather-icon class="mr-1" icon="DeleteIcon" />
                  <span class="align-middle ml-50">Borrar Filtro</span>
                </b-dropdown-item>
              </b-dropdown>
              </div>
              </span>
              <span v-else-if="props.column.field === 'fecha_reingreso'">
                <div class="text-nowrap">
                <b-dropdown
                    menu-class=""
                    size="sm"
                    variant="btn"
                    :toggle-class="`${fechaReingresoFiltroCabeceraTableSelected.length>0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                    :style="`${fechaReingresoFiltroCabeceraTableSelected.length>0 ? 'text-decoration: underline #fba820e6;' : ''}`"
                    block
                >
                  <template #button-content class="text-danger">
                  <b >FECHA REINGRESO <feather-icon class="float-right" icon="FilterIcon" /></b>

                </template>
                  <b-dropdown-form >
                  <b-form-group label="Filtrar Reingreso" label-for="fechReingresoFiltroCabeceraTableSelected" @click.prevent class="py-0 my-0">
                  <v-select
                      id="fechReingresoFiltroCabeceraTableSelected"
                      v-model="fechaReingresoFiltroCabeceraTableSelected"
                      :options="fechaReingresoFiltroCabeceraTableOpciones"
                      placeholder="Seleccionar reingreso ..."
                      multiple
                      class="select-size-sm"
                      @input="realizarFiltroCabeceraTable('fecha_reingreso', fechaReingresoFiltroCabeceraTableSelected,'=')"
                  />
                </b-form-group>
                </b-dropdown-form>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('fecha_reingreso', 'acs')">
                  <feather-icon class="mr-1" icon="ArrowDownIcon" />
                  <span class="align-middle ml-50">Ordenar Ascendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('fecha_reingreso', 'desc')">
                  <feather-icon class="mr-1" icon="ArrowUpIcon" />
                  <span class="align-middle ml-50">Ordenar Descendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="cancelarOrdenacionCabeceraTable('fecha_reingreso')">
                  <feather-icon class="mr-1" icon="RotateCcwIcon" />
                  <span class="align-middle ml-50">Cancelar Ordenación</span>
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>

                <b-dropdown-item @click="fechaReingresoFiltroCabeceraTableSelected=[]; realizarFiltroCabeceraTable('fecha_reingreso', [],'=')">
                  <feather-icon class="mr-1" icon="DeleteIcon" />
                  <span class="align-middle ml-50">Borrar Filtro</span>
                </b-dropdown-item>
              </b-dropdown>
              </div>
              </span>
              <span v-else-if="props.column.field =='dias_contrato_rango'">
              <div class="text-nowrap">
                <b-dropdown
                    menu-class=""
                    size="sm"
                    variant="btn"
                    :toggle-class="`${diasCtoRangoFiltroCabeceraTableOpciones.length>0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                    :style="`${diasCtoRangoFiltroCabeceraTableOpciones.length>0 ? 'text-decoration: underline #fba820e6;' : ''}`"
                    block
                >
                  <template #button-content >
                  <span style="font-weight: bold;" >{{props.column.label}}</span>
                  &nbsp;&nbsp;  <feather-icon class="float-right" icon="FilterIcon" />

                </template>
                 <b-dropdown-form >
                  <b-form-group label="Filtrar Días Cto." v-slot="{ ariaDescribedby }"  class="py-0 my-0">
                    <b-form-radio-group
                        id="btn-radios-1_1_0"
                        v-model="condicionalSelectedDiasCtoRango"
                        :options="condicionaOptionsDiasCtoRango"
                        :aria-describedby="ariaDescribedby"
                        button-variant="outline-primary"
                        buttons
                        size="sm"
                    ></b-form-radio-group>


                  </b-form-group>
                   <b-form-group  label-for="diasCtoRangoFiltroCabeceraTableSelected"  class="py-0 my-0">
                </b-form-group>

                </b-dropdown-form>
                  <b-dropdown-form >
                   <b-form-group  label-for="diasCtoRangoFiltroCabeceraTableSelected"  class="py-0 my-0">
                   <b-input-group  >

                    <b-form-input
                        id="idaDiasCtoRangoText"
                        placeholder="Ingrese valor"
                        v-model="diasCtoRangoText"
                        type="number"
                        size="sm" />

                    <b-input-group-append>
                      <b-button
                          variant="outline-info"
                          @click="realizarFiltroCabeceraTable('dias_contrato_rango', [diasCtoRangoText],condicionalSelectedDiasCtoRango)"
                          size="sm"
                      >
                         <feather-icon class="mr-2" icon="FilterIcon"/>
                        Filtrar
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                   <b-input-group  >

                       <b-alert
                           v-height-fade.appear
                           :show="dismissCountDownDiasCtoRango"
                           dismissible
                           class="mb-0"
                           variant="warning"
                           @dismissed="dismissCountDownDiasCtoRango = 0"
                           @dismiss-count-down="countDownChanged"
                           size="sm"
                       >
                      <div class="alert-body" style="font-size: 13px">
                        <span>Valor es requerido! &nbsp;&nbsp;</span>
                      </div>
                    </b-alert>

                  </b-input-group>
                </b-form-group>

                </b-dropdown-form>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('dias_contrato_rango', 'acs')">
                  <feather-icon class="mr-1" icon="ArrowDownIcon" />
                  <span class="align-middle ml-50">Ordenar Ascendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('dias_contrato_rango', 'desc')">
                  <feather-icon class="mr-1" icon="ArrowUpIcon" />
                  <span class="align-middle ml-50">Ordenar Descendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="cancelarOrdenacionCabeceraTable('dias_contrato_rango')">
                  <feather-icon class="mr-1" icon="RotateCcwIcon" />
                  <span class="align-middle ml-50">Cancelar Ordenación</span>
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="asistenciaFiltroCabeceraTableOpciones=[]; realizarFiltroCabeceraTable('dias_contrato_rango', [],'=')">
                  <feather-icon class="mr-1" icon="DeleteIcon" />
                  <span class="align-middle ml-50">Borrar Filtro</span>
                </b-dropdown-item>
              </b-dropdown>
              </div>
             </span>
              <span v-else-if="props.column.field === 'fecha_inicial_char'">
                <div class="text-nowrap">
                <b-dropdown
                    menu-class=""
                    size="sm"
                    variant="btn"
                    :toggle-class="`${fechaInicialRangoFiltroCabeceraTableSelected.length>0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                    :style="`${fechaInicialRangoFiltroCabeceraTableSelected.length>0 ? 'text-decoration: underline #fba820e6;' : ''}`"
                    block
                >
                  <template #button-content class="text-danger">
                  <b >FECHA RANGO INICIAL<feather-icon class="float-right" icon="FilterIcon" /></b>

                </template>
                  <b-dropdown-form >
                  <b-form-group label="Filtrar Reingreso" label-for="fechReingresoFiltroCabeceraTableSelected" @click.prevent class="py-0 my-0">
                  <v-select
                      id="fechaInicialRangoFiltroCabeceraTableSelected"
                      v-model="fechaInicialRangoFiltroCabeceraTableSelected"
                      :options="fechaInicialRangoFiltroCabeceraTableOpciones"
                      placeholder="Seleccionar FI Rango ..."
                      multiple
                      class="select-size-sm"
                      @input="realizarFiltroCabeceraTable('fecha_inicial_char', fechaInicialRangoFiltroCabeceraTableSelected,'=')"
                  />
                </b-form-group>
                </b-dropdown-form>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('fecha_inicial_char', 'acs')">
                  <feather-icon class="mr-1" icon="ArrowDownIcon" />
                  <span class="align-middle ml-50">Ordenar Ascendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('fecha_inicial_char', 'desc')">
                  <feather-icon class="mr-1" icon="ArrowUpIcon" />
                  <span class="align-middle ml-50">Ordenar Descendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="cancelarOrdenacionCabeceraTable('fecha_inicial_char')">
                  <feather-icon class="mr-1" icon="RotateCcwIcon" />
                  <span class="align-middle ml-50">Cancelar Ordenación</span>
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>

                <b-dropdown-item @click="fechaInicialRangoFiltroCabeceraTableOpciones=[]; realizarFiltroCabeceraTable('fecha_inicial_char', [],'=')">
                  <feather-icon class="mr-1" icon="DeleteIcon" />
                  <span class="align-middle ml-50">Borrar Filtro</span>
                </b-dropdown-item>
              </b-dropdown>
              </div>
              </span>
              <span v-else-if="props.column.field === 'fecha_final_char'">
                <div class="text-nowrap">
                <b-dropdown
                    menu-class=""
                    size="sm"
                    variant="btn"
                    :toggle-class="`${fechaInicialRangoFiltroCabeceraTableSelected.length>0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                    :style="`${fechaInicialRangoFiltroCabeceraTableSelected.length>0 ? 'text-decoration: underline #fba820e6;' : ''}`"
                    block
                >
                  <template #button-content class="text-danger">
                  <b >FECHA RANGO FINAL<feather-icon class="float-right" icon="FilterIcon" /></b>

                </template>
                  <b-dropdown-form >
                  <b-form-group label="Filtrar Reingreso" label-for="fechaFinalRangoFiltroCabeceraTableSelected" @click.prevent class="py-0 my-0">
                  <v-select
                      id="fechaFinalRangoFiltroCabeceraTableSelected"
                      v-model="fechaFinalRangoFiltroCabeceraTableSelected"
                      :options="fechaFinalRangoFiltroCabeceraTableOpciones"
                      placeholder="Seleccionar FF Rango ..."
                      multiple
                      class="select-size-sm"
                      @input="realizarFiltroCabeceraTable('fecha_final_char', fechaFinalRangoFiltroCabeceraTableSelected,'=')"
                  />
                </b-form-group>
                </b-dropdown-form>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('fecha_final_char', 'acs')">
                  <feather-icon class="mr-1" icon="ArrowDownIcon" />
                  <span class="align-middle ml-50">Ordenar Ascendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('fecha_final_char', 'desc')">
                  <feather-icon class="mr-1" icon="ArrowUpIcon" />
                  <span class="align-middle ml-50">Ordenar Descendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="cancelarOrdenacionCabeceraTable('fecha_final_char')">
                  <feather-icon class="mr-1" icon="RotateCcwIcon" />
                  <span class="align-middle ml-50">Cancelar Ordenación</span>
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>

                <b-dropdown-item @click="fechaFinalRangoFiltroCabeceraTableOpciones=[]; realizarFiltroCabeceraTable('fecha_inicial_char', [],'=')">
                  <feather-icon class="mr-1" icon="DeleteIcon" />
                  <span class="align-middle ml-50">Borrar Filtro</span>
                </b-dropdown-item>
              </b-dropdown>
              </div>
              </span>
              <span v-else-if="props.column.field =='total_labores_rango'">
              <div class="text-nowrap">
                <b-dropdown
                    menu-class=""
                    size="sm"
                    variant="btn"
                    :toggle-class="`${totalTareoRangoFiltroCabeceraTableOpciones.length>0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                    :style="`${totalTareoRangoFiltroCabeceraTableOpciones.length>0 ? 'text-decoration: underline #fba820e6;' : ''}`"
                    block
                >
                  <template #button-content >
                  <span style="font-weight: bold;" >{{props.column.label}}</span>
                  &nbsp;&nbsp;  <feather-icon class="float-right" icon="FilterIcon" />

                </template>
                 <b-dropdown-form >
                  <b-form-group label="Filtrar Días Cto." v-slot="{ ariaDescribedby }"  class="py-0 my-0">
                    <b-form-radio-group
                        id="id_totalTareoRangoFiltroCabeceraTableSelected"
                        v-model="condicionalSelectedtotalTareoRango"
                        :options="condicionaOptionsTotalTareoRango"
                        :aria-describedby="ariaDescribedby"
                        button-variant="outline-primary"
                        buttons
                        size="sm"
                    ></b-form-radio-group>


                  </b-form-group>
                   <b-form-group  label-for="totalTareoRangoFiltroCabeceraTableSelected"  class="py-0 my-0">
                </b-form-group>

                </b-dropdown-form>
                  <b-dropdown-form >
                   <b-form-group  label-for="totalTareoRangoFiltroCabeceraTableSelected"  class="py-0 my-0">
                   <b-input-group  >

                    <b-form-input
                        id="idtotalTareoRangoText"
                        placeholder="Ingrese valor"
                        v-model="totalTareoRangoText"
                        type="number"
                        size="sm" />

                    <b-input-group-append>
                      <b-button
                          variant="outline-info"
                          @click="realizarFiltroCabeceraTable('total_labores_rango', [totalTareoRangoText],condicionalSelectedtotalTareoRango)"
                          size="sm"
                      >
                         <feather-icon class="mr-2" icon="FilterIcon"/>
                        Filtrar
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                   <b-input-group  >

                       <b-alert
                           v-height-fade.appear
                           :show="dismissCountDownTotalTareoRango"
                           dismissible
                           class="mb-0"
                           variant="warning"
                           @dismissed="dismissCountDownTotalTareoRango = 0"
                           @dismiss-count-down="countDownChanged"
                           size="sm"
                       >
                      <div class="alert-body" style="font-size: 13px">
                        <span>Valor es requerido! &nbsp;&nbsp;</span>
                      </div>
                    </b-alert>

                  </b-input-group>
                </b-form-group>

                </b-dropdown-form>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('total_labores_rango', 'acs')">
                  <feather-icon class="mr-1" icon="ArrowDownIcon" />
                  <span class="align-middle ml-50">Ordenar Ascendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('total_labores_rango', 'desc')">
                  <feather-icon class="mr-1" icon="ArrowUpIcon" />
                  <span class="align-middle ml-50">Ordenar Descendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="cancelarOrdenacionCabeceraTable('total_labores_rango')">
                  <feather-icon class="mr-1" icon="RotateCcwIcon" />
                  <span class="align-middle ml-50">Cancelar Ordenación</span>
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="totalTareoRangoFiltroCabeceraTableOpciones=[]; realizarFiltroCabeceraTable('total_labores_rango', [],'=')">
                  <feather-icon class="mr-1" icon="DeleteIcon" />
                  <span class="align-middle ml-50">Borrar Filtro</span>
                </b-dropdown-item>
              </b-dropdown>
              </div>
             </span>
              <span v-else-if="props.column.field =='total_otras_labores_rango'">
              <div class="text-nowrap">
                <b-dropdown
                    menu-class=""
                    size="sm"
                    variant="btn"
                    :toggle-class="`${totalOtraLaborRangoFiltroCabeceraTableOpciones.length>0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                    :style="`${totalOtraLaborRangoFiltroCabeceraTableOpciones.length>0 ? 'text-decoration: underline #fba820e6;' : ''}`"
                    block
                >
                  <template #button-content >
                  <span style="font-weight: bold;" >{{props.column.label}}</span>
                  &nbsp;&nbsp;  <feather-icon class="float-right" icon="FilterIcon" />

                </template>
                 <b-dropdown-form >
                  <b-form-group label="Filtrar Días Cto." v-slot="{ ariaDescribedby }"  class="py-0 my-0">
                    <b-form-radio-group
                        id="btn-condicionalSelectedtotalTareoRango"
                        v-model="condicionalSelectedtotalOtraLaborRango"
                        :options="condicionaOptionstotalOtraLaborRango"
                        :aria-describedby="ariaDescribedby"
                        button-variant="outline-primary"
                        buttons
                        size="sm"
                    ></b-form-radio-group>


                  </b-form-group>
                   <b-form-group  label-for="totalOtraLaborRangoFiltroCabeceraTableOpciones"  class="py-0 my-0">
                </b-form-group>

                </b-dropdown-form>
                  <b-dropdown-form >
                   <b-form-group  label-for="totalOtraLaborRangoFiltroCabeceraTableOpciones"  class="py-0 my-0">
                   <b-input-group  >

                    <b-form-input
                        id="idtotalOtraLaborRangoText"
                        placeholder="Ingrese valor"
                        v-model="totalOtraLaborRangoText"
                        type="number"
                        size="sm" />

                    <b-input-group-append>
                      <b-button
                          variant="outline-info"
                          @click="realizarFiltroCabeceraTable('total_otras_labores_rango', [totalOtraLaborRangoText],condicionalSelectedtotalOtraLaborRango)"
                          size="sm"
                      >
                         <feather-icon class="mr-2" icon="FilterIcon"/>
                        Filtrar
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                   <b-input-group  >

                       <b-alert
                           v-height-fade.appear
                           :show="dismissCountDowntotalOtraLaborRango"
                           dismissible
                           class="mb-0"
                           variant="warning"
                           @dismissed="dismissCountDowntotalOtraLaborRango = 0"
                           @dismiss-count-down="countDownChanged"
                           size="sm"
                       >
                      <div class="alert-body" style="font-size: 13px">
                        <span>Valor es requerido! &nbsp;&nbsp;</span>
                      </div>
                    </b-alert>

                  </b-input-group>
                </b-form-group>

                </b-dropdown-form>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('total_otras_labores_rango', 'acs')">
                  <feather-icon class="mr-1" icon="ArrowDownIcon" />
                  <span class="align-middle ml-50">Ordenar Ascendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('total_otras_labores_rango', 'desc')">
                  <feather-icon class="mr-1" icon="ArrowUpIcon" />
                  <span class="align-middle ml-50">Ordenar Descendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="cancelarOrdenacionCabeceraTable('total_otras_labores_rango')">
                  <feather-icon class="mr-1" icon="RotateCcwIcon" />
                  <span class="align-middle ml-50">Cancelar Ordenación</span>
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="totalOtraLaborRangoFiltroCabeceraTableOpciones=[]; realizarFiltroCabeceraTable('total_otras_labores_rango', [],'=')">
                  <feather-icon class="mr-1" icon="DeleteIcon" />
                  <span class="align-middle ml-50">Borrar Filtro</span>
                </b-dropdown-item>
              </b-dropdown>
              </div>
             </span>
              <span v-else-if="props.column.field =='nro_dias_cosecha_rango'">
              <div class="text-nowrap">
                <b-dropdown
                    menu-class=""
                    size="sm"
                    variant="btn"
                    :toggle-class="`${diasCosechaRangoFiltroCabeceraTableOpciones.length>0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                    :style="`${diasCosechaRangoFiltroCabeceraTableOpciones.length>0 ? 'text-decoration: underline #fba820e6;' : ''}`"
                    block
                >
                  <template #button-content >
                  <span style="font-weight: bold;" >{{props.column.label}}</span>
                  &nbsp;&nbsp;  <feather-icon class="float-right" icon="FilterIcon" />

                </template>
                 <b-dropdown-form >
                  <b-form-group label="Filtrar Días Cosecha." v-slot="{ ariaDescribedby }"  class="py-0 my-0">
                    <b-form-radio-group
                        id="btn-ddiass_cosecha"
                        v-model="condicionalSelecteddiasCosechaRango"
                        :options="condicionaOptionsdiasCosecharRango"
                        :aria-describedby="ariaDescribedby"
                        button-variant="outline-primary"
                        buttons
                        size="sm"
                    ></b-form-radio-group>


                  </b-form-group>
                   <b-form-group  label-for="diasCosechaRangoFiltroCabeceraTableOpciones"  class="py-0 my-0">
                </b-form-group>

                </b-dropdown-form>
                  <b-dropdown-form >
                   <b-form-group  label-for="diasCosechaRangoFiltroCabeceraTableOpciones"  class="py-0 my-0">
                   <b-input-group  >

                    <b-form-input
                        id="iddiasCosechaRangoTextt"
                        placeholder="Ingrese valor"
                        v-model="diasCosechaRangoText"
                        type="number"
                        size="sm" />

                    <b-input-group-append>
                      <b-button
                          variant="outline-info"
                          @click="realizarFiltroCabeceraTable('nro_dias_cosecha_rango', [diasCosechaRangoText],condicionalSelecteddiasCosechaRango)"
                          size="sm"
                      >
                         <feather-icon class="mr-2" icon="FilterIcon"/>
                        Filtrar
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                   <b-input-group  >

                       <b-alert
                           v-height-fade.appear
                           :show="dismissCountDowndiasCosechaRango"
                           dismissible
                           class="mb-0"
                           variant="warning"
                           @dismissed="dismissCountDowndiasCosechaRango = 0"
                           @dismiss-count-down="countDownChanged"
                           size="sm"
                       >
                      <div class="alert-body" style="font-size: 13px">
                        <span>Valor es requerido! &nbsp;&nbsp;</span>
                      </div>
                    </b-alert>

                  </b-input-group>
                </b-form-group>

                </b-dropdown-form>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('nro_dias_cosecha_rango', 'acs')">
                  <feather-icon class="mr-1" icon="ArrowDownIcon" />
                  <span class="align-middle ml-50">Ordenar Ascendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('nro_dias_cosecha_rango', 'desc')">
                  <feather-icon class="mr-1" icon="ArrowUpIcon" />
                  <span class="align-middle ml-50">Ordenar Descendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="cancelarOrdenacionCabeceraTable('nro_dias_cosecha_rango')">
                  <feather-icon class="mr-1" icon="RotateCcwIcon" />
                  <span class="align-middle ml-50">Cancelar Ordenación</span>
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="diasCosechaRangoFiltroCabeceraTableOpciones=[]; realizarFiltroCabeceraTable('nro_dias_cosecha_rango', [],'=')">
                  <feather-icon class="mr-1" icon="DeleteIcon" />
                  <span class="align-middle ml-50">Borrar Filtro</span>
                </b-dropdown-item>
              </b-dropdown>
              </div>
             </span>
              <span v-else-if="props.column.field =='jaba_total_rango'">
              <div class="text-nowrap">
                <b-dropdown
                    menu-class=""
                    size="sm"
                    variant="btn"
                    :toggle-class="`${jabaTotalRangoFiltroCabeceraTableOpciones.length>0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                    :style="`${jabaTotalRangoFiltroCabeceraTableOpciones.length>0 ? 'text-decoration: underline #fba820e6;' : ''}`"
                    block
                >
                  <template #button-content >
                  <span style="font-weight: bold;" >{{props.column.label}}</span>
                  &nbsp;&nbsp;  <feather-icon class="float-right" icon="FilterIcon" />

                </template>
                 <b-dropdown-form >
                  <b-form-group label="Filtrar Días Cto." v-slot="{ ariaDescribedby }"  class="py-0 my-0">
                    <b-form-radio-group
                        id="btn-condicionalSelectedjabaTotalRango"
                        v-model="condicionalSelectedjabaTotalRango"
                        :options="condicionaOptionsjabaTotalRango"
                        :aria-describedby="ariaDescribedby"
                        button-variant="outline-primary"
                        buttons
                        size="sm"
                    ></b-form-radio-group>


                  </b-form-group>
                   <b-form-group  label-for="diasCtoRangoFiltroCabeceraTableSelected"  class="py-0 my-0">
                </b-form-group>

                </b-dropdown-form>
                  <b-dropdown-form >
                   <b-form-group  label-for="diasCtoRangoFiltroCabeceraTableSelected"  class="py-0 my-0">
                   <b-input-group  >

                    <b-form-input
                        id="idjabaTotalRangoText"
                        placeholder="Ingrese valor"
                        v-model="jabaTotalRangoText"
                        type="number"
                        size="sm" />

                    <b-input-group-append>
                      <b-button
                          variant="outline-info"
                          @click="realizarFiltroCabeceraTable('jaba_total_rango', [jabaTotalRangoText],condicionalSelectedjabaTotalRango)"
                          size="sm"
                      >
                         <feather-icon class="mr-2" icon="FilterIcon"/>
                        Filtrar
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                   <b-input-group  >

                       <b-alert
                           v-height-fade.appear
                           :show="dismissCountDownjabaTotalRango"
                           dismissible
                           class="mb-0"
                           variant="warning"
                           @dismissed="dismissCountDownjabaTotalRango = 0"
                           @dismiss-count-down="countDownChanged"
                           size="sm"
                       >
                      <div class="alert-body" style="font-size: 13px">
                        <span>Valor es requerido! &nbsp;&nbsp;</span>
                      </div>
                    </b-alert>

                  </b-input-group>
                </b-form-group>

                </b-dropdown-form>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('jaba_total_rango', 'acs')">
                  <feather-icon class="mr-1" icon="ArrowDownIcon" />
                  <span class="align-middle ml-50">Ordenar Ascendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('jaba_total_rango', 'desc')">
                  <feather-icon class="mr-1" icon="ArrowUpIcon" />
                  <span class="align-middle ml-50">Ordenar Descendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="cancelarOrdenacionCabeceraTable('jaba_total_rango')">
                  <feather-icon class="mr-1" icon="RotateCcwIcon" />
                  <span class="align-middle ml-50">Cancelar Ordenación</span>
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="jabaTotalRangoFiltroCabeceraTableOpciones=[]; realizarFiltroCabeceraTable('jaba_total_rango', [],'=')">
                  <feather-icon class="mr-1" icon="DeleteIcon" />
                  <span class="align-middle ml-50">Borrar Filtro</span>
                </b-dropdown-item>
              </b-dropdown>
              </div>
             </span>
              <span v-else-if="props.column.field === 'porcentaje_dia_cosecha'">

                 <div class="text-nowrap">
                    <b-dropdown
                        menu-class=""
                        size="sm"
                        variant="btn"
                        :toggle-class="`${cosechaHistoricoFiltroCabeceraTableOpciones.length>0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                        :style="`${cosechaHistoricoFiltroCabeceraTableOpciones.length>0 ? 'text-decoration: underline #fba820e6;' : ''}`"
                        block
                    >
                  <template #button-content >
                  <span style="font-weight: bold;color: #0F95F1" >{{props.column.label}}</span>
                  &nbsp;&nbsp;  <feather-icon class="float-right" icon="FilterIcon" style="color: #0F95F1" />

                </template>
                 <b-dropdown-form >
                  <b-form-group label="Filtrar días Cosecha Rango" v-slot="{ ariaDescribedby }"  class="py-0 my-0">
                    <b-form-radio-group
                        id="btn-radios-3"
                        v-model="condicionalSelectedCosRango"
                        :options="condicionaOptionsCosRango"
                        :aria-describedby="ariaDescribedby"
                        button-variant="outline-primary"
                        buttons
                        size="sm"
                    ></b-form-radio-group>


                  </b-form-group>
                   <b-form-group  label-for="cosechaRangoFiltroCabeceraTableSelected"  class="py-0 my-0">

                </b-form-group>

                </b-dropdown-form>
                  <b-dropdown-form >
                   <b-form-group  label-for="cosechaRangoFiltroCabeceraTableSelected"  class="py-0 my-0">
                   <b-input-group  >

                    <b-form-input
                        id="idcosechaRangoText"
                        placeholder="Ingrese valor"
                        v-model="cosechaRangoText"
                        type="number"
                        size="sm" />
                    <b-input-group-append>
                      <b-button
                          variant="outline-info"
                          @click="realizarFiltroCabeceraTable('porcentaje_dia_cosecha', [cosechaRangoText],condicionalSelectedCosRango)"
                          size="sm"

                      >
                         <feather-icon class="mr-2" icon="FilterIcon"/>
                        Filtrar
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                     <b-input-group  >

                       <b-alert
                           v-height-fade.appear
                           :show="dismissCountDownCosRango"
                           dismissible
                           class="mb-0"
                           variant="warning"
                           @dismissed="dismissCountDownCosRango = 0"
                           @dismiss-count-down="countDownChangedCosRango"
                           size="sm"
                       >
                      <div class="alert-body" style="font-size: 13px">
                        <span>Valor es requerido! &nbsp;&nbsp;</span>
                      </div>
                    </b-alert>

                  </b-input-group>
                </b-form-group>

                </b-dropdown-form>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('porcentaje_dia_cosecha', 'acs')">
                  <feather-icon class="mr-1" icon="ArrowDownIcon" />
                  <span class="align-middle ml-50">Ordenar Ascendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('porcentaje_dia_cosecha', 'desc')">
                  <feather-icon class="mr-1" icon="ArrowUpIcon" />
                  <span class="align-middle ml-50">Ordenar Descendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="cancelarOrdenacionCabeceraTable('porcentaje_dia_cosecha')">
                  <feather-icon class="mr-1" icon="RotateCcwIcon" />
                  <span class="align-middle ml-50">Cancelar Ordenación</span>
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="asistenciaFiltroCabeceraTableOpciones=[]; realizarFiltroCabeceraTable('porcentaje_dia_cosecha', [],'=')">
                  <feather-icon class="mr-1" icon="DeleteIcon" />
                  <span class="align-middle ml-50">Borrar Filtro</span>
                </b-dropdown-item>
              </b-dropdown>
                  </div>
            </span>
              <span v-else-if="props.column.field === 'porcentaje_dia_cosecha_historico'">
                  <div class="text-nowrap">
                    <b-dropdown
                        menu-class=""
                        size="sm"
                        variant="btn"
                        :toggle-class="`${cosechaHistoricoFiltroCabeceraTableOpciones.length>0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                        :style="`${cosechaHistoricoFiltroCabeceraTableOpciones.length>0 ? 'text-decoration: underline #fba820e6;' : ''}`"
                        block
                    >
                  <template #button-content >
                  <span style="font-weight: bold; color: #0F95F1">{{props.column.label}}</span>
                  &nbsp;&nbsp;  <feather-icon class="float-right" icon="FilterIcon" style="color: #0F95F1" />

                </template>
                 <b-dropdown-form >
                  <b-form-group label="Filtrar Cosecha Historico" v-slot="{ ariaDescribedby }"  class="py-0 my-0">
                    <b-form-radio-group
                        id="btn-radios-2"
                        v-model="condicionalSelectedCosHistorico"
                        :options="condicionaOptionsCosHistorico"
                        :aria-describedby="ariaDescribedby"
                        button-variant="outline-primary"
                        buttons
                        size="sm"
                    ></b-form-radio-group>


                  </b-form-group>
                   <b-form-group  label-for="cosechaHistoricoFiltroCabeceraTableSelected"  class="py-0 my-0">

                </b-form-group>

                </b-dropdown-form>
                  <b-dropdown-form >
                   <b-form-group  label-for="cosechaHistoricoFiltroCabeceraTableSelected"  class="py-0 my-0">
                   <b-input-group  >

                    <b-form-input
                        id="idcosechaHistoricoText"
                        placeholder="Ingrese valor"
                        v-model="cosechaHistoricoText"
                        type="number"
                        size="sm" />
                    <b-input-group-append>
                      <b-button
                          variant="outline-info"
                          @click="realizarFiltroCabeceraTable('porcentaje_dia_cosecha_historico', [cosechaHistoricoText],condicionalSelectedCosHistorico)"
                          size="sm"

                      >
                         <feather-icon class="mr-2" icon="FilterIcon"/>
                        Filtrar
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                     <b-input-group  >

                       <b-alert
                           v-height-fade.appear
                           :show="dismissCountDownCosHistorico"
                           dismissible
                           class="mb-0"
                           variant="warning"
                           @dismissed="dismissCountDownCosHistorico = 0"
                           @dismiss-count-down="countDownChangedCosHistorico"
                           size="sm"
                       >
                      <div class="alert-body" style="font-size: 13px">
                        <span>Valor es requerido! &nbsp;&nbsp;</span>
                      </div>
                    </b-alert>

                  </b-input-group>
                </b-form-group>

                </b-dropdown-form>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('porcentaje_dia_cosecha_historico', 'acs')">
                  <feather-icon class="mr-1" icon="ArrowDownIcon" />
                  <span class="align-middle ml-50">Ordenar Ascendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('porcentaje_dia_cosecha_historico', 'desc')">
                  <feather-icon class="mr-1" icon="ArrowUpIcon" />
                  <span class="align-middle ml-50">Ordenar Descendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="cancelarOrdenacionCabeceraTable('porcentaje_dia_cosecha_historico')">
                  <feather-icon class="mr-1" icon="RotateCcwIcon" />
                  <span class="align-middle ml-50">Cancelar Ordenación</span>
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="asistenciaFiltroCabeceraTableOpciones=[]; realizarFiltroCabeceraTable('porcentaje_dia_cosecha_historico', [],'=')">
                  <feather-icon class="mr-1" icon="DeleteIcon" />
                  <span class="align-middle ml-50">Borrar Filtro</span>
                </b-dropdown-item>
              </b-dropdown>
                  </div>

            </span>
              <span v-else-if="props.column.field =='porcentaje_asistencia_rango'">
              <div class="text-nowrap">
                <b-dropdown
                    menu-class=""
                    size="sm"
                    variant="btn"
                    :toggle-class="`${asistenciaFiltroCabeceraTableOpciones.length>0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                    :style="`${asistenciaFiltroCabeceraTableOpciones.length>0 ? 'text-decoration: underline #fba820e6;' : ''}`"
                    block
                >
                  <template #button-content >
                  <span style="font-weight: bold;" class="text-success">{{props.column.label}}</span>
                  &nbsp;&nbsp;  <feather-icon class="float-right text-success" icon="FilterIcon" />

                </template>
                 <b-dropdown-form >
                  <b-form-group label="Filtrar Asistencia" v-slot="{ ariaDescribedby }"  class="py-0 my-0">
                    <b-form-radio-group
                        id="btn-radios-1"
                        v-model="condicionalSelectedAsistencia"
                        :options="condicionaOptionsAsistencia"
                        :aria-describedby="ariaDescribedby"
                        button-variant="outline-primary"
                        buttons
                        size="sm"
                    ></b-form-radio-group>


                  </b-form-group>
                   <b-form-group  label-for="trabajadorFiltroCabeceraTableSelected"  class="py-0 my-0">
                </b-form-group>

                </b-dropdown-form>
                  <b-dropdown-form >
                   <b-form-group  label-for="trabajadorFiltroCabeceraTableSelected"  class="py-0 my-0">
                   <b-input-group  >

                    <b-form-input
                        id="idasistenciaRangoText"
                        placeholder="Ingrese valor"
                        v-model="asistenciaRangoText"
                        type="number"
                        size="sm" />

                    <b-input-group-append>
                      <b-button
                          variant="outline-info"
                          @click="realizarFiltroCabeceraTable('porcentaje_asistencia_rango', [asistenciaRangoText],condicionalSelectedAsistencia)"
                          size="sm"
                      >
                         <feather-icon class="mr-2" icon="FilterIcon"/>
                        Filtrar
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                   <b-input-group  >

                       <b-alert
                           v-height-fade.appear
                           :show="dismissCountDown"
                           dismissible
                           class="mb-0"
                           variant="warning"
                           @dismissed="dismissCountDown = 0"
                           @dismiss-count-down="countDownChanged"
                           size="sm"
                       >
                      <div class="alert-body" style="font-size: 13px">
                        <span>Valor es requerido! &nbsp;&nbsp;</span>
                      </div>
                    </b-alert>

                  </b-input-group>
                </b-form-group>

                </b-dropdown-form>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('porcentaje_asistencia_rango', 'acs')">
                  <feather-icon class="mr-1" icon="ArrowDownIcon" />
                  <span class="align-middle ml-50">Ordenar Ascendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('porcentaje_asistencia_rango', 'desc')">
                  <feather-icon class="mr-1" icon="ArrowUpIcon" />
                  <span class="align-middle ml-50">Ordenar Descendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="cancelarOrdenacionCabeceraTable('porcentaje_asistencia_rango')">
                  <feather-icon class="mr-1" icon="RotateCcwIcon" />
                  <span class="align-middle ml-50">Cancelar Ordenación</span>
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="asistenciaFiltroCabeceraTableOpciones=[]; realizarFiltroCabeceraTable('porcentaje_asistencia_rango', [],'=')">
                  <feather-icon class="mr-1" icon="DeleteIcon" />
                  <span class="align-middle ml-50">Borrar Filtro</span>
                </b-dropdown-item>
              </b-dropdown>
              </div>
             </span>
              <span v-else-if="props.column.field =='porcentaje_asistencia_rango_asistencia_global_final'">

                <div class="text-nowrap">
                <b-dropdown
                    menu-class=""
                    size="sm"
                    variant="btn"
                    :toggle-class="`${asistenciaFiltroCabeceraTableOpciones.length>0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                    :style="`${asistenciaFiltroCabeceraTableOpciones.length>0 ? 'text-decoration: underline #fba820e6;' : ''}`"
                    block
                >
                  <template #button-content >
                  <span style="font-weight: bold;" >ASIS. {{ultimoDiaAsistencia}} DÍAS RANGO</span>
                  &nbsp;&nbsp;  <feather-icon class="float-right" icon="FilterIcon" />

                </template>
                 <b-dropdown-form >
                  <b-form-group label="Filtrar Asistencia" v-slot="{ ariaDescribedby }"  class="py-0 my-0">
                    <b-form-radio-group
                        id="btn-radios-1_11"
                        v-model="condicionalSelectedDiasAsistencia"
                        :options="condicionaOptionsDiasAsistencia"
                        :aria-describedby="ariaDescribedby"
                        button-variant="outline-primary"
                        buttons
                        size="sm"
                    ></b-form-radio-group>


                  </b-form-group>
                   <b-form-group  label-for="diasAsistenciaFiltroCabeceraTableSelected"  class="py-0 my-0">
                </b-form-group>

                </b-dropdown-form>
                  <b-dropdown-form >
                   <b-form-group  label-for="diasAsistenciaFiltroCabeceraTableSelected"  class="py-0 my-0">
                   <b-input-group  >

                    <b-form-input
                        id="iddiasAsistenciaRangoText"
                        placeholder="Ingrese valor"
                        v-model="diasAsistenciaRangoText"
                        type="number"
                        size="sm" />

                    <b-input-group-append>
                      <b-button
                          variant="outline-info"
                          @click="realizarFiltroCabeceraTable('porcentaje_asistencia_rango_asistencia_global_final', [diasAsistenciaRangoText],condicionalSelectedDiasAsistencia)"
                          size="sm"
                      >
                         <feather-icon class="mr-2" icon="FilterIcon"/>
                        Filtrar
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                   <b-input-group  >

                       <b-alert
                           v-height-fade.appear
                           :show="dismissCountDownDiasAsistencia"
                           dismissible
                           class="mb-0"
                           variant="warning"
                           @dismissed="dismissCountDownDiasAsistencia = 0"
                           @dismiss-count-down="countDownChanged"
                           size="sm"
                       >
                      <div class="alert-body" style="font-size: 13px">
                        <span>Valor es requerido! &nbsp;&nbsp;</span>
                      </div>
                    </b-alert>

                  </b-input-group>
                </b-form-group>

                </b-dropdown-form>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('porcentaje_asistencia_rango_asistencia_global_final', 'acs')">
                  <feather-icon class="mr-1" icon="ArrowDownIcon" />
                  <span class="align-middle ml-50">Ordenar Ascendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('porcentaje_asistencia_rango_asistencia_global_final', 'desc')">
                  <feather-icon class="mr-1" icon="ArrowUpIcon" />
                  <span class="align-middle ml-50">Ordenar Descendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="cancelarOrdenacionCabeceraTable('porcentaje_asistencia_rango_asistencia_global_final')">
                  <feather-icon class="mr-1" icon="RotateCcwIcon" />
                  <span class="align-middle ml-50">Cancelar Ordenación</span>
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="asistenciaFiltroCabeceraTableOpciones=[]; realizarFiltroCabeceraTable('porcentaje_asistencia_rango_asistencia_global_final', [],'=')">
                  <feather-icon class="mr-1" icon="DeleteIcon" />
                  <span class="align-middle ml-50">Borrar Filtro</span>
                </b-dropdown-item>
              </b-dropdown>
              </div>
             </span>
              <span v-else-if="props.column.field =='promedio_aprendizaje'">
                 <div class="text-nowrap">
                <b-dropdown
                    menu-class=""
                    size="sm"
                    variant="btn"
                    :toggle-class="`${mediaAprendizajeFiltroCabeceraTableOpciones.length>0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                    :style="`${mediaAprendizajeFiltroCabeceraTableOpciones.length>0 ? 'text-decoration: underline #fba820e6;' : ''}`"
                    block
                >
                  <template #button-content >
                  <span style="font-weight: bold;" class="text-success">{{props.column.label}}</span>
                  &nbsp;&nbsp;  <feather-icon class="float-right text-success" icon="FilterIcon" />

                </template>
                 <b-dropdown-form >
                  <b-form-group label="Filtrar Aprendizaje" v-slot="{ ariaDescribedby }"  class="py-0 my-0">
                    <b-form-radio-group
                        id="btn-radios-1_1"
                        v-model="condicionalSelectedMediaAprendizaje"
                        :options="condicionaOptionsMediaAprendizaje"
                        :aria-describedby="ariaDescribedby"
                        button-variant="outline-primary"
                        buttons
                        size="sm"
                    ></b-form-radio-group>


                  </b-form-group>
                   <b-form-group  label-for="mediaAprendizajeFiltroCabeceraTableSelected"  class="py-0 my-0">
                </b-form-group>

                </b-dropdown-form>
                  <b-dropdown-form >
                   <b-form-group  label-for="mediaAprendizajeFiltroCabeceraTableSelected"  class="py-0 my-0">
                   <b-input-group  >

                    <b-form-input
                        id="idmediaAprendizajeRangoText"
                        placeholder="Ingrese valor"
                        v-model="mediaAprendizajeRangoText"
                        type="number"
                        size="sm" />

                    <b-input-group-append>
                      <b-button
                          variant="outline-info"
                          @click="realizarFiltroCabeceraTable('promedio_aprendizaje', [mediaAprendizajeRangoText],condicionalSelectedMediaAprendizaje)"
                          size="sm"
                      >
                         <feather-icon class="mr-2" icon="FilterIcon"/>
                        Filtrar
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                   <b-input-group  >

                       <b-alert
                           v-height-fade.appear
                           :show="dismissCountDownMediaAprendizaje"
                           dismissible
                           class="mb-0"
                           variant="warning"
                           @dismissed="dismissCountDownMediaAprendizaje = 0"
                           @dismiss-count-down="countDownChanged"
                           size="sm"
                       >
                      <div class="alert-body" style="font-size: 13px">
                        <span>Valor es requerido! &nbsp;&nbsp;</span>
                      </div>
                    </b-alert>

                  </b-input-group>
                </b-form-group>

                </b-dropdown-form>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('promedio_aprendizaje', 'acs')">
                  <feather-icon class="mr-1" icon="ArrowDownIcon" />
                  <span class="align-middle ml-50">Ordenar Ascendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('promedio_aprendizaje', 'desc')">
                  <feather-icon class="mr-1" icon="ArrowUpIcon" />
                  <span class="align-middle ml-50">Ordenar Descendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="cancelarOrdenacionCabeceraTable('promedio_aprendizaje')">
                  <feather-icon class="mr-1" icon="RotateCcwIcon" />
                  <span class="align-middle ml-50">Cancelar Ordenación</span>
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="mediaAprendizajeFiltroCabeceraTableOpciones=[]; realizarFiltroCabeceraTable('promedio_aprendizaje', [],'=')">
                  <feather-icon class="mr-1" icon="DeleteIcon" />
                  <span class="align-middle ml-50">Borrar Filtro</span>
                </b-dropdown-item>
              </b-dropdown>
              </div>
             </span>
              <span v-else-if="props.column.field =='resultado_condicion_rango_redondeo'">
                 <div class="text-nowrap">
                <b-dropdown
                    menu-class=""
                    size="sm"
                    variant="btn"
                    :toggle-class="`${resultadoCondicionRangoFiltroCabeceraTableOpciones.length>0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                    :style="`${resultadoCondicionRangoFiltroCabeceraTableOpciones.length>0 ? 'text-decoration: underline #fba820e6;' : ''}`"
                    block
                >
                  <template #button-content >
                  <span style="font-weight: bold;color: #0F95F1" class="text-success">{{props.column.label}} {{condicion}} %</span>
                  &nbsp;&nbsp;  <feather-icon class="float-right text-success" icon="FilterIcon" />

                </template>
                 <b-dropdown-form >
                  <b-form-group label="Filtrar Condición" v-slot="{ ariaDescribedby }"  class="py-0 my-0">
                    <b-form-radio-group
                        id="btn-radios-condición"
                        v-model="condicionalSelectedresultadoCondicionRango"
                        :options="condicionaOptionsresultadoCondicionRango"
                        :aria-describedby="ariaDescribedby"
                        button-variant="outline-primary"
                        buttons
                        size="sm"
                    ></b-form-radio-group>


                  </b-form-group>
                   <b-form-group  label-for="resultadoCondicionRangoFiltroCabeceraTableSelected"  class="py-0 my-0">
                </b-form-group>

                </b-dropdown-form>
                  <b-dropdown-form >
                   <b-form-group  label-for="resultadoCondicionRangoFiltroCabeceraTableSelected"  class="py-0 my-0">
                   <b-input-group  >

                    <b-form-input
                        id="idresultadoCondicionRangoText"
                        placeholder="Ingrese valor"
                        v-model="resultadoCondicionRangoText"
                        type="number"
                        size="sm" />

                    <b-input-group-append>
                      <b-button
                          variant="outline-info"
                          @click="realizarFiltroCabeceraTable('resultado_condicion_rango_redondeo', [resultadoCondicionRangoText],condicionalSelectedresultadoCondicionRango)"
                          size="sm"
                      >
                         <feather-icon class="mr-2" icon="FilterIcon"/>
                        Filtrar
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                   <b-input-group  >

                       <b-alert
                           v-height-fade.appear
                           :show="dismissCountDownresultadoCondicionRango"
                           dismissible
                           class="mb-0"
                           variant="warning"
                           @dismissed="dismissCountDownresultadoCondicionRango = 0"
                           @dismiss-count-down="countDownChanged"
                           size="sm"
                       >
                      <div class="alert-body" style="font-size: 13px">
                        <span>Valor es requerido! &nbsp;&nbsp;</span>
                      </div>
                    </b-alert>

                  </b-input-group>
                </b-form-group>

                </b-dropdown-form>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('resultado_condicion_rango_redondeo', 'acs')">
                  <feather-icon class="mr-1" icon="ArrowDownIcon" />
                  <span class="align-middle ml-50">Ordenar Ascendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('resultado_condicion_rango_redondeo', 'desc')">
                  <feather-icon class="mr-1" icon="ArrowUpIcon" />
                  <span class="align-middle ml-50">Ordenar Descendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="cancelarOrdenacionCabeceraTable('resultado_condicion_rango_redondeo')">
                  <feather-icon class="mr-1" icon="RotateCcwIcon" />
                  <span class="align-middle ml-50">Cancelar Ordenación</span>
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="resultadoCondicionRangoFiltroCabeceraTableOpciones=[]; realizarFiltroCabeceraTable('resultado_condicion_rango_redondeo', [],'=')">
                  <feather-icon class="mr-1" icon="DeleteIcon" />
                  <span class="align-middle ml-50">Borrar Filtro</span>
                </b-dropdown-item>
              </b-dropdown>
              </div>
             </span>
              <span v-else-if="props.column.field =='promedio_cumplimiento_cuadrilla_rango_redondeo'">
                 <div class="text-nowrap">
                <b-dropdown
                    menu-class=""
                    size="sm"
                    variant="btn"
                    :toggle-class="`${promedioCumplimientoRangoFiltroCabeceraTableOpciones.length>0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                    :style="`${promedioCumplimientoRangoFiltroCabeceraTableOpciones.length>0 ? 'text-decoration: underline #fba820e6;' : ''}`"
                    block
                >
                  <template #button-content >
                  <span style="font-weight: bold;" class="text-success">{{props.column.label}}</span>
                  &nbsp;&nbsp;  <feather-icon class="float-right text-success" icon="FilterIcon" />

                </template>
                 <b-dropdown-form >
                  <b-form-group label="Filtrar Promedio" v-slot="{ ariaDescribedby }"  class="py-0 my-0">
                    <b-form-radio-group
                        id="btn-radios-promedio"
                        v-model="condicionalSelectedpromedioCumplimientoRango"
                        :options="condicionaOptionspromedioCumplimientoRango"
                        :aria-describedby="ariaDescribedby"
                        button-variant="outline-primary"
                        buttons
                        size="sm"
                    ></b-form-radio-group>


                  </b-form-group>
                   <b-form-group  label-for="promedioCumplimientoRangoFiltroCabeceraTableSelected"  class="py-0 my-0">
                </b-form-group>

                </b-dropdown-form>
                  <b-dropdown-form >
                   <b-form-group  label-for="promedioCumplimientoRangoFiltroCabeceraTableSelected"  class="py-0 my-0">
                   <b-input-group  >

                    <b-form-input
                        id="idpromedioCumplimientoRangoText"
                        placeholder="Ingrese valor"
                        v-model="promedioCumplimientoRangoText"
                        type="number"
                        size="sm" />

                    <b-input-group-append>
                      <b-button
                          variant="outline-info"
                          @click="realizarFiltroCabeceraTable('promedio_cumplimiento_cuadrilla_rango_redondeo', [promedioCumplimientoRangoText],condicionalSelectedpromedioCumplimientoRango)"
                          size="sm"
                      >
                         <feather-icon class="mr-2" icon="FilterIcon"/>
                        Filtrar
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                   <b-input-group  >

                       <b-alert
                           v-height-fade.appear
                           :show="dismissCountDownpromedioCumplimientoRango"
                           dismissible
                           class="mb-0"
                           variant="warning"
                           @dismissed="dismissCountDownpromedioCumplimientoRango = 0"
                           @dismiss-count-down="countDownChanged"
                           size="sm"
                       >
                      <div class="alert-body" style="font-size: 13px">
                        <span>Valor es requerido! &nbsp;&nbsp;</span>
                      </div>
                    </b-alert>

                  </b-input-group>
                </b-form-group>

                </b-dropdown-form>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('promedio_cumplimiento_cuadrilla_rango_redondeo', 'acs')">
                  <feather-icon class="mr-1" icon="ArrowDownIcon" />
                  <span class="align-middle ml-50">Ordenar Ascendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('promedio_cumplimiento_cuadrilla_rango_redondeo', 'desc')">
                  <feather-icon class="mr-1" icon="ArrowUpIcon" />
                  <span class="align-middle ml-50">Ordenar Descendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="cancelarOrdenacionCabeceraTable('promedio_cumplimiento_cuadrilla_rango_redondeo')">
                  <feather-icon class="mr-1" icon="RotateCcwIcon" />
                  <span class="align-middle ml-50">Cancelar Ordenación</span>
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="promedioCumplimientoRangoFiltroCabeceraTableOpciones=[]; realizarFiltroCabeceraTable('promedio_cumplimiento_cuadrilla_rango_redondeo', [],'=')">
                  <feather-icon class="mr-1" icon="DeleteIcon" />
                  <span class="align-middle ml-50">Borrar Filtro</span>
                </b-dropdown-item>
              </b-dropdown>
              </div>
             </span>
              <span v-else-if="props.column.field =='prom_campania_anterior_rango_redondeo'">
                 <div class="text-nowrap">
                <b-dropdown
                    menu-class=""
                    size="sm"
                    variant="btn"
                    :toggle-class="`${promedioCumplimientoCampAnteriorRangoFiltroCabeceraTableOpciones.length>0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                    :style="`${promedioCumplimientoCampAnteriorRangoFiltroCabeceraTableOpciones.length>0 ? 'text-decoration: underline #fba820e6;' : ''}`"
                    block
                >
                  <template #button-content >
                  <span style="font-weight: bold;" >{{props.column.label}}</span>
                  &nbsp;&nbsp;  <feather-icon class="float-right" icon="FilterIcon" />

                </template>
                 <b-dropdown-form >
                  <b-form-group label="Filtrar Promedio" v-slot="{ ariaDescribedby }"  class="py-0 my-0">
                    <b-form-radio-group
                        id="btn-radios-promedioCampAnterior"
                        v-model="condicionalSelectedpromedioCumplimientoCampAnteriorRango"
                        :options="condicionaOptionspromedioCumplimientoCampAnteriorRango"
                        :aria-describedby="ariaDescribedby"
                        button-variant="outline-primary"
                        buttons
                        size="sm"
                    ></b-form-radio-group>


                  </b-form-group>
                   <b-form-group  label-for="promedioCumplimientoCampAnteriorRangoFiltroCabeceraTableSelected"  class="py-0 my-0">
                </b-form-group>

                </b-dropdown-form>
                  <b-dropdown-form >
                   <b-form-group  label-for="promedioCumplimientoCampAnteriorRangoFiltroCabeceraTableSelected"  class="py-0 my-0">
                   <b-input-group  >

                    <b-form-input
                        id="idpromedioCumplimientoCampAnteriorRangoText"
                        placeholder="Ingrese valor"
                        v-model="promedioCumplimientoCampAnteriorRangoText"
                        type="number"
                        size="sm" />

                    <b-input-group-append>
                      <b-button
                          variant="outline-info"
                          @click="realizarFiltroCabeceraTable('prom_campania_anterior_rango_redondeo', [promedioCumplimientoCampAnteriorRangoText],condicionalSelectedpromedioCumplimientoCampAnteriorRango)"
                          size="sm"
                      >
                         <feather-icon class="mr-2" icon="FilterIcon"/>
                        Filtrar
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                   <b-input-group  >

                       <b-alert
                           v-height-fade.appear
                           :show="dismissCountDownpromedioCumplimientoCampAnteriorRango"
                           dismissible
                           class="mb-0"
                           variant="warning"
                           @dismissed="dismissCountDownpromedioCumplimientoCampAnteriorRango = 0"
                           @dismiss-count-down="countDownChanged"
                           size="sm"
                       >
                      <div class="alert-body" style="font-size: 13px">
                        <span>Valor es requerido! &nbsp;&nbsp;</span>
                      </div>
                    </b-alert>

                  </b-input-group>
                </b-form-group>

                </b-dropdown-form>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('prom_campania_anterior_rango_redondeo', 'acs')">
                  <feather-icon class="mr-1" icon="ArrowDownIcon" />
                  <span class="align-middle ml-50">Ordenar Ascendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('prom_campania_anterior_rango_redondeo', 'desc')">
                  <feather-icon class="mr-1" icon="ArrowUpIcon" />
                  <span class="align-middle ml-50">Ordenar Descendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="cancelarOrdenacionCabeceraTable('prom_campania_anterior_rango_redondeo')">
                  <feather-icon class="mr-1" icon="RotateCcwIcon" />
                  <span class="align-middle ml-50">Cancelar Ordenación</span>
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="promedioCumplimientoRangoFiltroCabeceraTableOpciones=[]; realizarFiltroCabeceraTable('prom_campania_anterior_rango_redondeo', [],'=')">
                  <feather-icon class="mr-1" icon="DeleteIcon" />
                  <span class="align-middle ml-50">Borrar Filtro</span>
                </b-dropdown-item>
              </b-dropdown>
              </div>
             </span>
              <span v-else-if="props.column.field =='promedio_cumplimiento_cuadrilla_rango_redondeo_r1'">
                 <div class="text-nowrap">
                <b-dropdown
                    menu-class=""
                    size="sm"
                    variant="btn"
                    :toggle-class="`${promedioCumplimientoR1FiltroCabeceraTableOpciones.length>0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                    :style="`${promedioCumplimientoR1FiltroCabeceraTableOpciones.length>0 ? 'text-decoration: underline #fba820e6;' : ''}`"
                    block
                >
                  <template #button-content >
                  <span style="font-weight: bold;">{{props.column.label}}</span>
                  &nbsp;&nbsp;  <feather-icon class="float-right" icon="FilterIcon" />

                </template>
                 <b-dropdown-form >
                  <b-form-group label="Filtrar Ap. R1" v-slot="{ ariaDescribedby }"  class="py-0 my-0">
                    <b-form-radio-group
                        id="btn-radios-apren_r1"
                        v-model="condicionalSelectedpromedioCumplimientoR1Rango"
                        :options="condicionaOptionspromedioCumplimientoR1Rango"
                        :aria-describedby="ariaDescribedby"
                        button-variant="outline-primary"
                        buttons
                        size="sm"
                    ></b-form-radio-group>


                  </b-form-group>
                   <b-form-group  label-for="promedioCumplimientoR1RangoFiltroCabeceraTableSelected"  class="py-0 my-0">
                </b-form-group>

                </b-dropdown-form>
                  <b-dropdown-form >
                   <b-form-group  label-for="promedioCumplimientoR1RangoFiltroCabeceraTableSelected"  class="py-0 my-0">
                   <b-input-group  >

                    <b-form-input
                        id="idpromedioCumplimientoR1RangoText"
                        placeholder="Ingrese valor"
                        v-model="promedioCumplimientoR1RangoText"
                        type="number"
                        size="sm" />

                    <b-input-group-append>
                      <b-button
                          variant="outline-info"
                          @click="realizarFiltroCabeceraTable('promedio_cumplimiento_cuadrilla_rango_redondeo_r1', [promedioCumplimientoR1RangoText],condicionalSelectedpromedioCumplimientoR1Rango)"
                          size="sm"
                      >
                         <feather-icon class="mr-2" icon="FilterIcon"/>
                        Filtrar
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                   <b-input-group  >

                       <b-alert
                           v-height-fade.appear
                           :show="dismissCountDownpromedioCumplimientoR1Rango"
                           dismissible
                           class="mb-0"
                           variant="warning"
                           @dismissed="dismissCountDownpromedioCumplimientoR1Rango = 0"
                           @dismiss-count-down="countDownChanged"
                           size="sm"
                       >
                      <div class="alert-body" style="font-size: 13px">
                        <span>Valor es requerido! &nbsp;&nbsp;</span>
                      </div>
                    </b-alert>

                  </b-input-group>
                </b-form-group>

                </b-dropdown-form>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('promedio_cumplimiento_cuadrilla_rango_redondeo_r1', 'acs')">
                  <feather-icon class="mr-1" icon="ArrowDownIcon" />
                  <span class="align-middle ml-50">Ordenar Ascendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('promedio_cumplimiento_cuadrilla_rango_redondeo_r1', 'desc')">
                  <feather-icon class="mr-1" icon="ArrowUpIcon" />
                  <span class="align-middle ml-50">Ordenar Descendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="cancelarOrdenacionCabeceraTable('promedio_cumplimiento_cuadrilla_rango_redondeo_r1')">
                  <feather-icon class="mr-1" icon="RotateCcwIcon" />
                  <span class="align-middle ml-50">Cancelar Ordenación</span>
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="promedioCumplimientoR1FiltroCabeceraTableOpciones=[]; realizarFiltroCabeceraTable('promedio_cumplimiento_cuadrilla_rango_redondeo_r1', [],'=')">
                  <feather-icon class="mr-1" icon="DeleteIcon" />
                  <span class="align-middle ml-50">Borrar Filtro</span>
                </b-dropdown-item>
              </b-dropdown>
              </div>
             </span>
              <span v-else-if="props.column.field =='promedio_cumplimiento_cuadrilla_rango_redondeo_r2'">
                 <div class="text-nowrap">
                <b-dropdown
                    menu-class=""
                    size="sm"
                    variant="btn"
                    :toggle-class="`${promedioCumplimientoR2RangoFiltroCabeceraTableOpciones.length>0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                    :style="`${promedioCumplimientoR2RangoFiltroCabeceraTableOpciones.length>0 ? 'text-decoration: underline #fba820e6;' : ''}`"
                    block
                >
                  <template #button-content >
                  <span style="font-weight: bold;">{{props.column.label}}</span>
                  &nbsp;&nbsp;  <feather-icon class="float-right" icon="FilterIcon" />

                </template>
                 <b-dropdown-form >
                  <b-form-group label="Filtrar Ap. R2" v-slot="{ ariaDescribedby }"  class="py-0 my-0">
                    <b-form-radio-group
                        id="btn-radios-apren_r2"
                        v-model="condicionalSelectedpromedioCumplimientoR2Rango"
                        :options="condicionaOptionspromedioCumplimientoR2Rango"
                        :aria-describedby="ariaDescribedby"
                        button-variant="outline-primary"
                        buttons
                        size="sm"
                    ></b-form-radio-group>


                  </b-form-group>
                   <b-form-group  label-for="promedioCumplimientoR2RangoFiltroCabeceraTableSelected"  class="py-0 my-0">
                </b-form-group>

                </b-dropdown-form>
                  <b-dropdown-form >
                   <b-form-group  label-for="promedioCumplimientoR2RangoFiltroCabeceraTableSelected"  class="py-0 my-0">
                   <b-input-group  >

                    <b-form-input
                        id="idpromedioCumplimientoR2RangoText"
                        placeholder="Ingrese valor"
                        v-model="promedioCumplimientoR2RangoText"
                        type="number"
                        size="sm" />

                    <b-input-group-append>
                      <b-button
                          variant="outline-info"
                          @click="realizarFiltroCabeceraTable('promedio_cumplimiento_cuadrilla_rango_redondeo_r2', [promedioCumplimientoR2RangoText],condicionalSelectedpromedioCumplimientoR2Rango)"
                          size="sm"
                      >
                         <feather-icon class="mr-2" icon="FilterIcon"/>
                        Filtrar
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                   <b-input-group  >

                       <b-alert
                           v-height-fade.appear
                           :show="dismissCountDownpromedioCumplimientoR2Rango"
                           dismissible
                           class="mb-0"
                           variant="warning"
                           @dismissed="dismissCountDownpromedioCumplimientoR2Rango = 0"
                           @dismiss-count-down="countDownChanged"
                           size="sm"
                       >
                      <div class="alert-body" style="font-size: 13px">
                        <span>Valor es requerido! &nbsp;&nbsp;</span>
                      </div>
                    </b-alert>

                  </b-input-group>
                </b-form-group>

                </b-dropdown-form>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('promedio_cumplimiento_cuadrilla_rango_redondeo_r2', 'acs')">
                  <feather-icon class="mr-1" icon="ArrowDownIcon" />
                  <span class="align-middle ml-50">Ordenar Ascendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('promedio_cumplimiento_cuadrilla_rango_redondeo_r2', 'desc')">
                  <feather-icon class="mr-1" icon="ArrowUpIcon" />
                  <span class="align-middle ml-50">Ordenar Descendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="cancelarOrdenacionCabeceraTable('promedio_cumplimiento_cuadrilla_rango_redondeo_r2')">
                  <feather-icon class="mr-1" icon="RotateCcwIcon" />
                  <span class="align-middle ml-50">Cancelar Ordenación</span>
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="promedioCumplimientoR2RangoFiltroCabeceraTableOpciones=[]; realizarFiltroCabeceraTable('promedio_cumplimiento_cuadrilla_rango_redondeo_r2', [],'=')">
                  <feather-icon class="mr-1" icon="DeleteIcon" />
                  <span class="align-middle ml-50">Borrar Filtro</span>
                </b-dropdown-item>
              </b-dropdown>
              </div>
             </span>
              <span v-else-if="props.column.field =='calculado'">
                 <div class="text-nowrap">
                <b-dropdown
                    menu-class=""
                    size="sm"
                    variant="btn"
                    :toggle-class="`${calculadoRangoFiltroCabeceraTableOpciones.length>0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                    :style="`${calculadoRangoFiltroCabeceraTableOpciones.length>0 ? 'text-decoration: underline #fba820e6;' : ''}`"
                    block
                >
                  <template #button-content >
                  <span style="font-weight: bold;" class="text-info">{{props.column.label}}</span>
                  &nbsp;&nbsp;  <feather-icon class="float-right text-info" icon="FilterIcon" />

                </template>
                 <b-dropdown-form >
                  <b-form-group label="Filtrar Cálculo" v-slot="{ ariaDescribedby }"  class="py-0 my-0">
                    <b-form-radio-group
                        id="btn-radios-calculado"
                        v-model="condicionalSelectedcalculadoRango"
                        :options="condicionaOptionscalculadoRango"
                        :aria-describedby="ariaDescribedby"
                        button-variant="outline-primary"
                        buttons
                        size="sm"
                    ></b-form-radio-group>


                  </b-form-group>
                   <b-form-group  label-for="calculadoRangoFiltroCabeceraTableSelected"  class="py-0 my-0">
                </b-form-group>

                </b-dropdown-form>
                  <b-dropdown-form >
                   <b-form-group  label-for="calculadoRangoFiltroCabeceraTableSelected"  class="py-0 my-0">
                   <b-input-group  >

                    <b-form-input
                        id="idpcalculadoRangoText"
                        placeholder="Ingrese valor"
                        v-model="calculadoRangoText"
                        type="number"
                        size="sm" />

                    <b-input-group-append>
                      <b-button
                          variant="outline-info"
                          @click="realizarFiltroCabeceraTable('calculado', [calculadoRangoText],condicionalSelectedcalculadoRango)"
                          size="sm"
                      >
                         <feather-icon class="mr-2" icon="FilterIcon"/>
                        Filtrar
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                   <b-input-group  >

                       <b-alert
                           v-height-fade.appear
                           :show="dismissCountDowncalculadoRango"
                           dismissible
                           class="mb-0"
                           variant="warning"
                           @dismissed="dismissCountDowncalculadoRango = 0"
                           @dismiss-count-down="countDownChanged"
                           size="sm"
                       >
                      <div class="alert-body" style="font-size: 13px">
                        <span>Valor es requerido! &nbsp;&nbsp;</span>
                      </div>
                    </b-alert>

                  </b-input-group>
                </b-form-group>

                </b-dropdown-form>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('calculado', 'acs')">
                  <feather-icon class="mr-1" icon="ArrowDownIcon" />
                  <span class="align-middle ml-50">Ordenar Ascendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('calculado', 'desc')">
                  <feather-icon class="mr-1" icon="ArrowUpIcon" />
                  <span class="align-middle ml-50">Ordenar Descendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="cancelarOrdenacionCabeceraTable('calculado')">
                  <feather-icon class="mr-1" icon="RotateCcwIcon" />
                  <span class="align-middle ml-50">Cancelar Ordenación</span>
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="calculadoRangoFiltroCabeceraTableOpciones=[]; realizarFiltroCabeceraTable('calculado', [],'=')">
                  <feather-icon class="mr-1" icon="DeleteIcon" />
                  <span class="align-middle ml-50">Borrar Filtro</span>
                </b-dropdown-item>
              </b-dropdown>
              </div>
             </span>
              <span v-else-if="props.column.field === 'categoria_rango'">
                <div class="text-nowrap">
                  <b-dropdown
                      menu-class=""
                      size="sm"
                      variant="btn"
                      :toggle-class="`${categoriaRangoFiltroCabeceraTableSelected.length>0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                      :style="`${categoriaRangoFiltroCabeceraTableSelected.length>0 ? 'text-decoration: underline #fba820e6;' : ''}`"
                      block
                  >
                  <template #button-content class="text-danger">
                  <b > CATEGORIA RANGO<feather-icon class="float-right" icon="FilterIcon" /></b>

                </template>
                  <b-dropdown-form >
                  <b-form-group label="Filtrar Empresa" label-for="categoriaRangoFiltroCabeceraTableSelected" @click.prevent class="py-0 my-0">
                  <v-select
                      id="eidcategoriaRangoFiltroCabeceraTableSelected"
                      v-model="categoriaRangoFiltroCabeceraTableSelected"
                      :options="categoriaRangoFiltroCabeceraTableOpciones"
                      multiple
                      placeholder="Seleccionar ..."
                      class="select-size-sm"
                      @input="realizarFiltroCabeceraTable('categoria_rango', categoriaRangoFiltroCabeceraTableSelected,'=')"
                  />
                </b-form-group>
                </b-dropdown-form>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('categoria_rango', 'acs')">
                  <feather-icon class="mr-1" icon="ArrowDownIcon" />
                  <span class="align-middle ml-50">Ordenar Ascendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('categoria_rango', 'desc')">
                  <feather-icon class="mr-1" icon="ArrowUpIcon" />
                  <span class="align-middle ml-50">Ordenar Descendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="cancelarOrdenacionCabeceraTable('categoria_rango')">
                  <feather-icon class="mr-1" icon="RotateCcwIcon" />
                  <span class="align-middle ml-50">Cancelar Ordenación</span>
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>

                <b-dropdown-item @click="categoriaRangoFiltroCabeceraTableSelected=[]; realizarFiltroCabeceraTable('categoria_rango', [],'=')">
                  <feather-icon class="mr-1" icon="DeleteIcon" />
                  <span class="align-middle ml-50">Borrar Filtro</span>
                  </b-dropdown-item>
                  </b-dropdown>
                </div>

              </span>
              <span v-else-if="props.column.field === 'estado_proceso_observados'">
                <div class="text-nowrap">
                  <b-dropdown
                      menu-class=""
                      size="sm"
                      variant="btn"
                      :toggle-class="`${estadoProObservadosFiltroCabeceraTableSelected.length>0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                      :style="`${estadoProObservadosFiltroCabeceraTableSelected.length>0 ? 'text-decoration: underline #fba820e6;' : ''}`"
                      block
                  >
                  <template #button-content class="text-danger">
                  <b > ESTADO OBSERVADO	<feather-icon class="float-right" icon="FilterIcon" /></b>

                </template>
                  <b-dropdown-form >
                  <b-form-group label="Filtrar Estado" label-for="estadoProObservadosFiltroCabeceraTableSelected" @click.prevent class="py-0 my-0">
                  <v-select
                      id="eidestadoProObservadosFiltroCabeceraTableSelected"
                      v-model="estadoProObservadosFiltroCabeceraTableSelected"
                      :options="estadoProObservadosFiltroCabeceraTableOpciones"
                      multiple
                      placeholder="Seleccionar ..."
                      class="select-size-sm"
                      @input="realizarFiltroCabeceraTable('estado_proceso_observados', estadoProObservadosFiltroCabeceraTableSelected,'=')"
                  />
                </b-form-group>
                </b-dropdown-form>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('estado_proceso_observados', 'acs')">
                  <feather-icon class="mr-1" icon="ArrowDownIcon" />
                  <span class="align-middle ml-50">Ordenar Ascendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('estado_proceso_observados', 'desc')">
                  <feather-icon class="mr-1" icon="ArrowUpIcon" />
                  <span class="align-middle ml-50">Ordenar Descendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="cancelarOrdenacionCabeceraTable('estado_proceso_observados')">
                  <feather-icon class="mr-1" icon="RotateCcwIcon" />
                  <span class="align-middle ml-50">Cancelar Ordenación</span>
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>

                <b-dropdown-item @click="estadoProObservadosFiltroCabeceraTableSelected=[]; realizarFiltroCabeceraTable('estado_proceso_observados', [],'=')">
                  <feather-icon class="mr-1" icon="DeleteIcon" />
                  <span class="align-middle ml-50">Borrar Filtro</span>
                  </b-dropdown-item>
                  </b-dropdown>
                </div>

              </span>
              <span v-else-if="props.column.field === 'estado_cosecha'">
                <div class="text-nowrap">
                  <b-dropdown
                      menu-class=""
                      size="sm"
                      variant="btn"
                      :toggle-class="`${estadoCosechaFiltroCabeceraTableSelected.length>0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                      :style="`${estadoCosechaFiltroCabeceraTableSelected.length>0 ? 'text-decoration: underline #fba820e6;' : ''}`"
                      block
                  >
                  <template #button-content class="text-danger">
                  <b > ESTADO COSECHA	<feather-icon class="float-right" icon="FilterIcon" /></b>

                </template>
                  <b-dropdown-form >
                  <b-form-group label="Filtrar Estado" label-for="estadoProObservadosFiltroCabeceraTableSelected" @click.prevent class="py-0 my-0">
                  <v-select
                      id="idestadoCosechaFiltroCabeceraTableSelected"
                      v-model="estadoCosechaFiltroCabeceraTableSelected"
                      :options="estadoCosechaFiltroCabeceraTableOpciones"
                      multiple
                      placeholder="Seleccionar ..."
                      class="select-size-sm"
                      @input="realizarFiltroCabeceraTable('estado_cosecha', estadoCosechaFiltroCabeceraTableSelected,'=')"
                  />
                </b-form-group>
                </b-dropdown-form>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('estado_cosecha', 'acs')">
                  <feather-icon class="mr-1" icon="ArrowDownIcon" />
                  <span class="align-middle ml-50">Ordenar Ascendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('estado_cosecha', 'desc')">
                  <feather-icon class="mr-1" icon="ArrowUpIcon" />
                  <span class="align-middle ml-50">Ordenar Descendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="cancelarOrdenacionCabeceraTable('estado_cosecha')">
                  <feather-icon class="mr-1" icon="RotateCcwIcon" />
                  <span class="align-middle ml-50">Cancelar Ordenación</span>
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>

                <b-dropdown-item @click="estadoCosechaFiltroCabeceraTableSelected=[]; realizarFiltroCabeceraTable('estado_cosecha', [],'=')">
                  <feather-icon class="mr-1" icon="DeleteIcon" />
                  <span class="align-middle ml-50">Borrar Filtro</span>
                  </b-dropdown-item>
                  </b-dropdown>
                </div>

              </span>
              <span v-else-if="props.column.field === 'excluido'">
                <div class="text-nowrap">
                  <b-dropdown
                      menu-class=""
                      size="sm"
                      variant="btn"
                      :toggle-class="`${excluidoFiltroCabeceraTableSelected.length>0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                      :style="`${excluidoFiltroCabeceraTableSelected.length>0 ? 'text-decoration: underline #fba820e6;' : ''}`"
                      block
                  >
                  <template #button-content class="text-danger">
                  <b > EXCLUIDO	<feather-icon class="float-right" icon="FilterIcon" /></b>

                </template>
                  <b-dropdown-form >
                  <b-form-group label="Filtrar Excluido" label-for="excluidoFiltroCabeceraTableSelected" @click.prevent class="py-0 my-0">
                  <v-select
                      id="idExcluidoFiltroCabeceraTableSelected"
                      v-model="excluidoFiltroCabeceraTableSelected"
                      :options="excluidoFiltroCabeceraTableOpciones"
                      multiple
                      placeholder="Seleccionar ..."
                      class="select-size-sm"
                      @input="realizarFiltroCabeceraTable('excluido', excluidoFiltroCabeceraTableSelected,'=')"
                  />
                </b-form-group>
                </b-dropdown-form>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('excluido', 'acs')">
                  <feather-icon class="mr-1" icon="ArrowDownIcon" />
                  <span class="align-middle ml-50">Ordenar Ascendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="ordenarFieldsCabeceraTable('excluido', 'desc')">
                  <feather-icon class="mr-1" icon="ArrowUpIcon" />
                  <span class="align-middle ml-50">Ordenar Descendente</span>
                </b-dropdown-item>
                <b-dropdown-item @click="cancelarOrdenacionCabeceraTable('excluido')">
                  <feather-icon class="mr-1" icon="RotateCcwIcon" />
                  <span class="align-middle ml-50">Cancelar Ordenación</span>
                </b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>

                <b-dropdown-item @click="excluidoFiltroCabeceraTableSelected=[]; realizarFiltroCabeceraTable('excluido', [],'=')">
                  <feather-icon class="mr-1" icon="DeleteIcon" />
                  <span class="align-middle ml-50">Borrar Filtro</span>
                  </b-dropdown-item>
                  </b-dropdown>
                </div>

              </span>
              <span v-else>
                {{props.column.label}}
             </span>
            </template>
            <template slot="table-row" slot-scope="props" >

            <span v-if="props.column.field === 'dni_trabajador'">
              <span style="white-space: nowrap" >{{ props.row.dni_trabajador }}</span>
            </span>

              <!-- Column: Name -->
              <span v-else-if="props.column.field === 'nombres_trabajador'" >
              <span style="white-space: nowrap" >{{ props.row.nombres_trabajador }}</span>
            </span>

              <span v-else-if="props.column.field === 'fecha_penultima_contrato'" >
                &nbsp; &nbsp;
              <span style="white-space: nowrap" > {{props.formattedRow[props.column.field]}}</span>

            </span>


              <span v-else-if="props.column.field === 'fecha_reingreso'" class="text-nowrap" >
              <span class="text-nowrap">{{ props.row.fecha_reingreso }}</span>
            </span>

              <span v-else-if="props.column.field === 'categoria_rango'" class="text-nowrap" >
              <span class="text-nowrap">{{ props.row.categoria_rango }}</span>
            </span>

              <span v-else-if="props.column.field === 'promedio_cumplimiento_cuadrilla_rango_redondeo'" class="text-nowrap" >

              <feather-icon
                  :id="`btn_${props.row.promedio_cumplimiento_cuadrilla_rango_redondeo}_ver`"
                  icon="ServerIcon"
                  style="color: #198754"
                  size="16"
                  class="mx-1"
                  @click="mostrarModalEstadistico(props.row.nombres_trabajador,props.row.valor_maximo_rango,props.row.valor_minimo_rango,props.row.valor_desviacion_estandar_muestral_rango_redondeo)"
              />
            <b-tooltip
                title="Ver datos estadísticos"
                style="background-color:#198754"
                :target="`btn_${props.row.promedio_cumplimiento_cuadrilla_rango_redondeo}_ver`"
            />
              <span class="text-nowrap">{{ props.row.promedio_cumplimiento_cuadrilla_rango_redondeo }} %</span>
            </span>
              <span v-else-if="props.column.field === 'prom_campania_anterior_rango_redondeo'" class="text-nowrap" >

              <span class="text-nowrap">{{ props.row.prom_campania_anterior_rango_redondeo }} %</span>
              </span>
              <span v-else-if="props.column.field === 'promedio_cumplimiento_cuadrilla_rango_redondeo_r1'" class="text-nowrap" >
              <span class="text-nowrap" >{{ props.row.promedio_cumplimiento_cuadrilla_rango_redondeo_r1 }} %</span>
            </span>
              <span v-else-if="props.column.field === 'promedio_cumplimiento_cuadrilla_rango_redondeo_r2'" class="text-nowrap" >
              <span class="text-nowrap" >{{ props.row.promedio_cumplimiento_cuadrilla_rango_redondeo_r2 }} %</span>
            </span>
              <span v-else-if="props.column.field === 'promedio_aprendizaje'" class="text-nowrap" >
              <span class="text-nowrap" v-if="props.row.promedio_aprendizaje>=0 && props.row.estado_cosecha == 'NUEVO' ">{{ props.row.promedio_aprendizaje }} %</span>
              <span class="text-nowrap" style="color: red" v-else-if = "props.row.estado_cosecha == 'NUEVO'">{{ props.row.promedio_aprendizaje }} %</span>
              <span class="text-nowrap" style="color: red" v-else>NO APLICA</span>
            </span>

              <span v-else-if="props.column.field === 'valor_condicion_rango_redondeo'" class="text-nowrap" >
              <span class="text-nowrap">{{ props.row.valor_condicion_rango_redondeo }} %</span>
            </span>
              <span v-else-if="props.column.field === 'resultado_condicion_rango_redondeo'" class="text-nowrap" >
              <span class="text-nowrap">{{ props.row.resultado_condicion_rango_redondeo }} %</span>
            </span>

              <span v-else-if="props.column.field === 'porcentaje_dia_cosecha'" class="text-nowrap" >
              <span class="text-nowrap">{{ props.row.porcentaje_dia_cosecha }} %</span>
            </span>

              <span v-else-if="props.column.field === 'porcentaje_dia_cosecha_historico'" class="text-nowrap" >
              <feather-icon
                  :id="`btn_${props.row.promedio_cumplimiento_cuadrilla_rango_redondeo}_ver`"
                  icon="UserCheckIcon"
                  style="color: #0d6efd"
                  size="16"
                  class="mx-1"
                  @click="mostrarModalAsistenciaHistorico(props.row.nombres_trabajador,props.row.total_dia_tareo_historico_corte,props.row.total_dia_tareo_historico_otra_labores_corte,props.row.total_dia_tareo_historico_cosecha_corte,props.row.total_dia_falta_historico_corte,props.row.total_dias_empresa_historico)"
              />
            <b-tooltip
                title="Ver datos asistencia historico"
                style="background-color:#198754"
                :target="`btn_${props.row.promedio_cumplimiento_cuadrilla_rango_redondeo}_ver`"
            />

              <span class="text-nowrap">{{ props.row.porcentaje_dia_cosecha_historico }} %</span>
            </span>

              <span v-else-if="props.column.field === 'porcentaje_asistencia_rango'" class="text-nowrap" >


               <feather-icon
                   :id="`btn_${props.row.promedio_cumplimiento_cuadrilla_rango_redondeo}_ver`"
                   icon="UserCheckIcon"
                   style="color: #198754"
                   size="16"
                   class="mx-1"
                   @click="mostrarModalasistenciaRangoText(props.row.nombres_trabajador,props.row.total_dia_laborable_rango,props.row.dias_total_canjeado,props.row.total_falta_rango,props.row.total_labores_rango)"
               />
            <b-tooltip
                title="Ver datos asistencia historico"
                style="background-color:#198754"
                :target="`btn_${props.row.promedio_cumplimiento_cuadrilla_rango_redondeo}_ver`"
            />

              <span class="text-nowrap">{{ props.row.porcentaje_asistencia_rango }} %</span>
            </span>
              <span v-else-if="props.column.field === 'porcentaje_asistencia_rango_asistencia_global_final'" class="text-nowrap" >


               <feather-icon
                   :id="`btn_${props.row.dni_trabajador}_ver`"
                   icon="UserCheckIcon"
                   style="color: #198754"
                   size="16"
                   class="mx-1"
                   @click="mostrarModalasistenciaRangoTextGlobal(props.row.nombres_trabajador,props.row.total_dia_laborable_rango_asistencia_global,props.row.dias_total_canjeado_asistencia_global,props.row.total_falta_rango_asistencia_global,props.row.total_labores_rango_asistencia_global)"
               />
            <b-tooltip
                title="Ver datos ultimas asistencias"
                style="background-color:#198754"
                :target="`btn_${props.row.dni_trabajador}_ver`"
            />

              <span class="text-nowrap">{{ props.row.porcentaje_asistencia_rango_asistencia_global_final }} %</span>
            </span>


              <span v-else-if="props.column.field === 'calculado'" class="text-nowrap" >
              <feather-icon
                  icon="CheckCircleIcon"
                  style="color: #198754"
                  size="16"
                  class="mx-1"
                  v-if="props.row.color_semaforo == 'VERDE'"
              />

              <feather-icon
                  icon="AlertCircleIcon"
                  style="color: #fd7e14"
                  size="16"
                  class="mx-1"
                  v-else-if="props.row.color_semaforo == 'NARANJA'"
              />
              <feather-icon
                  icon="XCircleIcon"
                  style="color: #dc3545"
                  size="16"
                  class="mx-1"
                  v-else
              />

              <span class="text-nowrap "  style="color: green" v-if="props.row.color_semaforo == 'VERDE'">{{ props.row.calculado }} %</span>
              <span class="text-nowrap " style="color: orange" v-else-if="props.row.color_semaforo == 'NARANJA'">{{ props.row.calculado }} %</span>
              <span class="text-nowrap "  style="color: red" v-else>{{ props.row.calculado }} %</span>
            </span>


              <!-- Column: Status -->
              <span v-else-if="props.column.field === 'estado_cosecha'" class="text-body align-middle mr-25">
              <b-badge :variant="statusCosecha(props.row.estado_cosecha)">
               {{ props.row.estado_cosecha }}
                <!--  {{ salidaCosecha(props.row.estado_cosecha)}}-->
              </b-badge>
            </span>

              <span v-else-if="props.column.field === 'estado_proceso_observados'" class="text-body align-middle mr-25">
              <b-badge :variant="'light-warning'" v-if="props.row.estado_proceso_observados == 'REVERTIDO' " >
               {{ props.row.estado_proceso_observados }}
              </b-badge>
               <b-badge :variant="'light-success'" v-else>
                 {{ props.row.estado_proceso_observados }}
                 <!--  ------------->
              </b-badge>
            </span>

              <span v-else-if="props.column.field === 'nro_dias_cosecha_rango'" class="text-nowrap" >
              <span class="text-nowrap">{{ props.row.nro_dias_cosecha_rango }}</span>
              <feather-icon
                  :id="`btn_${props.row.nro_dias_cosecha_rango}_ver`"
                  icon="EyeIcon"
                  style="color: #2aa1a3"
                  size="16"
                  class="mx-1"
                  data-toggle="modal"
                  data-target="#exampleModal"
                  @click="mostrarModal(props.row.dni_trabajador,props.row.nombres_trabajador,props.row.fecha_rango_inicial,props.row.fecha_rango_final,props.row.codigo_empresa,props.row.promedio_cumplimiento_cuadrilla_rango_redondeo)"

              />
            <b-tooltip
                title="Ver Días Tareo"
                style="background-color:#E74C3C"
                :target="`btn_${props.row.nro_dias_cosecha_rango}_ver`"
            />
            </span>



              <!-- Column: Common -->
              <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
            </template>

            <template slot="loadingContent">

              <div class="text-center text-dark" v-if="loading">
                <b-spinner class="align-middle"></b-spinner> &emsp;
                <strong>Obteniendo datos...</strong>
              </div>


            </template>
            <div slot="emptystate" class="text-center text-dark my-1" v-if="!loading">
              No se encontraron datos con los parámetros ingresados
            </div>
            <div slot="emptystate" class="text-center text-dark my-3" v-if="loading">

            </div>

            <!-- pagination -->
            <template
                slot="pagination-bottom"
                slot-scope="props"
            >
              <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              Mostrando 1 a
            </span>
                  <b-form-select
                      v-model="pageLength"
                      :options="['3','5','10','20','50','100','200',props.total]"
                      class="mx-1"
                      @input="(value)=>props.perPageChanged({currentPerPage:value})"
                  />
                  <span class="text-nowrap"> de {{ props.total }} registros </span>
                </div>
                <div>
                  <b-pagination
                      :value="1"
                      :total-rows="props.total"
                      :per-page="pageLength"
                      first-number
                      last-number
                      align="right"
                      prev-class="prev-item"
                      next-class="next-item"
                      class="mt-1 mb-0"
                      @input="(value)=>props.pageChanged({currentPage:value})"
                  >
                    <template #prev-text>
                      <feather-icon
                          icon="ChevronLeftIcon"
                          size="18"
                      />
                    </template>
                    <template #next-text>
                      <feather-icon
                          icon="ChevronRightIcon"
                          size="18"
                      />
                    </template>
                  </b-pagination>
                </div>
              </div>
            </template>
          </vue-good-table>

        </div>
      </b-card-body>
      <div>



        <!-- Modal -->
        <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog  modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Lista de Tareos - Cumplimiento cuadrilla</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <b-row>
                  <b-col md="8">
                    <b-form-group
                    >

                      <div>{{ nombres_trabajador }}</div>

                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group
                    >

                      <div>PROMEDIO: <B class="text-info">{{ promedio_simples }} %</B> </div>

                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-table
                        hover
                        responsive
                        class="position-relative"

                        :per-page="perPage_c"
                        :current-page="currentPage_c"
                        :items="itemsTareos"
                        :fields="fieldsTareos"
                        :sort-by.sync="sortBy_c"
                        :sort-desc.sync="sortDesc_c"
                        :sort-direction="sortDirection_c"
                        :filter="filter_tareo"
                        :filter-included-fields="filterOnTareos"
                        @filtered="cPaginacion_c"
                        :busy="loading_c"
                        show-empty
                        empty-text="No se encontraron datos en esta tabla."
                        id="table-tareos"
                    >

                      <template #table-busy>
                        <div class="text-center text-dark my-1">
                          <b-spinner class="align-middle"></b-spinner> &emsp;
                          <strong>Obteniendo datos...</strong>
                        </div>
                      </template>


                      <template #cell(fecha_tareo)="data">
                        {{ data.value.split('-')[2] }}/{{ data.value.split('-')[1] }}/{{ data.value.split('-')[0] }}
                      </template>
                      <template #cell(cumplimiento_cuadrilla)="data">
                        <span style="white-space: nowrap">{{ data.value }} %</span>
                      </template>
                      <template #cell(categoria_rango)="data">
                        <span style="white-space: nowrap">{{ data.value }}</span>
                      </template>

                    </b-table>

                    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
                      <!-- page length -->
                      <b-form-group
                          label="Mostrar"
                          label-cols="5"
                          label-align="left"
                          label-size="sm"
                          label-for="sortBySelect"
                          class="text-nowrap mb-md-0 mr-1"
                      >
                        <b-form-select
                            id="perPageSelect2_c"
                            v-model="perPage_c"
                            size="sm"
                            inline
                            :options="pageOptions_c"
                        />

                      </b-form-group>

                      <!-- pagination -->
                      <div>
                        <b-pagination
                            v-model="currentPage_c"
                            :total-rows="totalRowsTareos"
                            :per-page="perPage_c"
                            first-number
                            last-number
                            prev-class="prev-item"
                            next-class="next-item"
                            class="mb-0"
                        >
                          <template #prev-text>
                            <feather-icon
                                icon="ChevronLeftIcon"
                                size="18"
                            />
                          </template>
                          <template #next-text>
                            <feather-icon
                                icon="ChevronRightIcon"
                                size="18"
                            />
                          </template>
                        </b-pagination>
                      </div>
                    </b-card-body>
                  </b-col>
                </b-row>


                <hr>
                <div class="hello" id="contenido">

                  <div class="text-center text-dark my-1" v-if="estadoGrafico">
                    <b-spinner class="align-middle"></b-spinner> &emsp;
                    <strong>Obteniendo gráfico...</strong>
                  </div>
                </div>

              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal" id="btncerrar" >Cerrar</button>
              </div>
            </div>
          </div>
        </div>
        <b-modal
            id="modalRegistro"
            v-model="estadoModal"
            :title="infoModal.title"
            hide-footer
            centered
            size="lg"
        >
          <form
              ref="form"
              @submit.stop.prevent="enviarFormulario"
          >

          </form>

        </b-modal>
        <b-modal
            id="modalDatosEstadisticos"
            v-model="estadoModalEstadistica"
            :title="infoModal.titleEstadistica"
            hide-footer
            centered
            size="sm"
        >
          <b-card
              class="card-transaction"
              no-body
          >
            <b-card-header>
              <span>{{nombres_trabajador}} </span>
              <b-dropdown
                  variant="link"
                  no-caret
                  class="chart-dropdown"
                  toggle-class="p-0"
                  right
              >
                <template #button-content>
                  <feather-icon
                      icon="SlidersIcon"
                      size="18"
                      class="text-body cursor-pointer"
                  />
                </template>
              </b-dropdown>

            </b-card-header>
            <b-card-body>
              <div
                  class="transaction-item"
              >
                <b-media no-body>
                  <b-media-aside>
                    <b-avatar
                        rounded
                        size="42"
                        :variant="'light-success'"
                    >
                      <feather-icon
                          size="18"
                          :icon="'TrendingUpIcon'"
                      />
                    </b-avatar> &nbsp;
                    <small>VALOR MÁXIMO RANGO</small>
                  </b-media-aside>
                </b-media>
                <div
                    class="font-weight-bolder"
                    :class="'text-success'"
                >
                  {{valor_maximo_rango}}
                </div>
              </div>
              <div
                  class="transaction-item"
              >
                <b-media no-body>
                  <b-media-aside>
                    <b-avatar
                        rounded
                        size="42"
                        :variant="'light-info'"
                    >
                      <feather-icon
                          size="18"
                          :icon="'TrendingDownIcon'"
                      />
                    </b-avatar> &nbsp;
                    <small>VALOR MÍNIMO RANGO</small>
                  </b-media-aside>
                </b-media>
                <div
                    class="font-weight-bolder"
                    :class="'text-info'"
                >
                  {{valor_minimo_rango}}
                </div>
              </div>
              <div
                  class="transaction-item"
              >
                <b-media no-body>
                  <b-media-aside>
                    <b-avatar
                        rounded
                        size="42"
                        :variant="'light-warning'"
                    >
                      <feather-icon
                          size="18"
                          :icon="'ActivityIcon'"
                      />
                    </b-avatar> &nbsp;
                    <small>DESVIACIÓN ESTÁNDAR</small>
                  </b-media-aside>
                </b-media>
                <div
                    class="font-weight-bolder"
                    :class="'text-warning'"
                >
                  {{valor_estandar_rango}}
                </div>
              </div>
            </b-card-body>


          </b-card>

        </b-modal>
        <b-modal
            id="modalDatosAsistencia"
            v-model="estadoModalAsistencia"
            :title="infoModal.titleAsistencia"
            hide-footer
            centered
            size="sm"
        >
          <b-card
              class="card-transaction"
              no-body
          >
            <b-card-header>
              <span>{{nombres_trabajador}} </span>
              <b-dropdown
                  variant="link"
                  no-caret
                  class="chart-dropdown"
                  toggle-class="p-0"
                  right
              >
                <template #button-content>
                  <feather-icon
                      icon="SlidersIcon"
                      size="18"
                      class="text-body cursor-pointer"
                  />
                </template>
              </b-dropdown>

            </b-card-header>
            <b-card-body>
              <div
                  class="transaction-item"
              >
                <b-media no-body>
                  <b-media-aside>
                    <b-avatar
                        rounded
                        size="42"
                        :variant="'light-success'"
                    >
                      <feather-icon
                          size="18"
                          :icon="'TrelloIcon'"
                      />
                    </b-avatar> &nbsp;
                    <small>TOTAL TAREO HISTORICO</small>
                  </b-media-aside>
                </b-media>
                <div
                    class="font-weight-bolder"
                    :class="'text-success'"
                >
                  {{valor_total_asis}}
                </div>
              </div>
              <div
                  class="transaction-item"
              >
                <b-media no-body>
                  <b-media-aside>
                    <b-avatar
                        rounded
                        size="42"
                        :variant="'light-info'"
                    >
                      <feather-icon
                          size="18"
                          :icon="'ColumnsIcon'"
                      />
                    </b-avatar> &nbsp;
                    <small>TOTAL LABORES HISTORICO</small>
                  </b-media-aside>
                </b-media>
                <div
                    class="font-weight-bolder"
                    :class="'text-info'"
                >
                  {{valor_otra_labor_asis}}
                </div>
              </div>
              <div
                  class="transaction-item"
              >
                <b-media no-body>
                  <b-media-aside>
                    <b-avatar
                        rounded
                        size="42"
                        :variant="'light-warning'"
                    >
                      <feather-icon
                          size="18"
                          :icon="'SidebarIcon'"
                      />
                    </b-avatar> &nbsp;
                    <small>TOTAL COSECHA HISTORICO</small>
                  </b-media-aside>
                </b-media>
                <div
                    class="font-weight-bolder"
                    :class="'text-warning'"
                >
                  {{valor_cosecha_asis}}
                </div>
              </div>
              <div
                  class="transaction-item"
              >
                <b-media no-body>
                  <b-media-aside>
                    <b-avatar
                        rounded
                        size="42"
                        :variant="'light-primary'"
                    >
                      <feather-icon
                          size="18"
                          :icon="'HashIcon'"
                      />
                    </b-avatar> &nbsp;
                    <small>TOTAL DÍAS EMPRESA</small>
                  </b-media-aside>
                </b-media>
                <div
                    class="font-weight-bolder"
                    :class="'text-primary'"
                >
                  {{valor_dias_empresa}}
                </div>
              </div>
              <div
                  class="transaction-item"
              >
                <b-media no-body>
                  <b-media-aside>
                    <b-avatar
                        rounded
                        size="42"
                        :variant="'light-danger'"
                    >
                      <feather-icon
                          size="18"
                          :icon="'HashIcon'"
                      />
                    </b-avatar> &nbsp;
                    <small>TOTAL FALTA HISTORICO</small>
                  </b-media-aside>
                </b-media>
                <div
                    class="font-weight-bolder"
                    :class="'text-danger'"
                >
                  {{valor_falta_asis}}
                </div>
              </div>
            </b-card-body>


          </b-card>

        </b-modal>
        <b-modal
            id="modalDatosasistenciaRangoText"
            v-model="estadoModalasistenciaRangoText"
            :title="infoModal.titleasistenciaRangoText"
            hide-footer
            centered
            size="sm"
        >
          <b-card
              class="card-transaction"
              no-body
          >
            <b-card-header>
              <span>{{nombres_trabajador}} </span>
              <b-dropdown
                  variant="link"
                  no-caret
                  class="chart-dropdown"
                  toggle-class="p-0"
                  right
              >
                <template #button-content>
                  <feather-icon
                      icon="SlidersIcon"
                      size="18"
                      class="text-body cursor-pointer"
                  />
                </template>
              </b-dropdown>

            </b-card-header>
            <b-card-body>
              <div
                  class="transaction-item"
              >
                <b-media no-body>
                  <b-media-aside>
                    <b-avatar
                        rounded
                        size="42"
                        :variant="'light-success'"
                    >
                      <feather-icon
                          size="18"
                          :icon="'TrelloIcon'"
                      />
                    </b-avatar> &nbsp;
                    <small>DÍAS OPERATIVO RANGO</small>
                  </b-media-aside>
                </b-media>
                <div
                    class="font-weight-bolder"
                    :class="'text-success'"
                >
                  {{valor_operativo_rango}}
                </div>
              </div>
              <div
                  class="transaction-item"
              >
                <b-media no-body>
                  <b-media-aside>
                    <b-avatar
                        rounded
                        size="42"
                        :variant="'light-info'"
                    >
                      <feather-icon
                          size="18"
                          :icon="'SidebarIcon'"
                      />
                    </b-avatar> &nbsp;
                    <small>DÍAS TAREOS RANGO</small>
                  </b-media-aside>
                </b-media>
                <div
                    class="font-weight-bolder"
                    :class="'text-info'"
                >
                  {{valor_dias_tareo_rango}}
                </div>
              </div>
              <div
                  class="transaction-item"
              >
                <b-media no-body>
                  <b-media-aside>
                    <b-avatar
                        rounded
                        size="42"
                        :variant="'light-warning'"
                    >
                      <feather-icon
                          size="18"
                          :icon="'ColumnsIcon'"
                      />
                    </b-avatar> &nbsp;
                    <small>DÍAS CANJEADO RANGO</small>
                  </b-media-aside>
                </b-media>
                <div
                    class="font-weight-bolder"
                    :class="'text-warning'"
                >
                  {{valor_canjeado_dias}}
                </div>
              </div>

              <div
                  class="transaction-item"
              >
                <b-media no-body>
                  <b-media-aside>
                    <b-avatar
                        rounded
                        size="42"
                        :variant="'light-primary'"
                    >
                      <feather-icon
                          size="18"
                          :icon="'HashIcon'"
                      />
                    </b-avatar> &nbsp;
                    <small>DÍAS FALTA RANGO</small>
                  </b-media-aside>
                </b-media>
                <div
                    class="font-weight-bolder"
                    :class="'text-primary'"
                >
                  {{valor_dias_falta_rango}}
                </div>
              </div>
            </b-card-body>


          </b-card>

        </b-modal>
        <b-modal
            id="modalDatosasistenciaRangoTextGlobal"
            v-model="estadoModalasistenciaRangoTextGlobal"
            :title="infoModal.titleasistenciaRangoTextGlobal"
            hide-footer
            centered
            size="sm"
        >
          <b-card
              class="card-transaction"
              no-body
          >
            <b-card-header>
              <span>{{nombres_trabajador}} </span>
              <b-dropdown
                  variant="link"
                  no-caret
                  class="chart-dropdown"
                  toggle-class="p-0"
                  right
              >
                <template #button-content>
                  <feather-icon
                      icon="SlidersIcon"
                      size="18"
                      class="text-body cursor-pointer"
                  />
                </template>
              </b-dropdown>

            </b-card-header>
            <b-card-body>
              <div
                  class="transaction-item"
              >
                <b-media no-body>
                  <b-media-aside>
                    <b-avatar
                        rounded
                        size="42"
                        :variant="'light-success'"
                    >
                      <feather-icon
                          size="18"
                          :icon="'TrelloIcon'"
                      />
                    </b-avatar> &nbsp;
                    <small>DÍAS OPERATIVO RANGO</small>
                  </b-media-aside>
                </b-media>
                <div
                    class="font-weight-bolder"
                    :class="'text-success'"
                >
                  {{valor_operativo_rango_global}}
                </div>
              </div>
              <div
                  class="transaction-item"
              >
                <b-media no-body>
                  <b-media-aside>
                    <b-avatar
                        rounded
                        size="42"
                        :variant="'light-info'"
                    >
                      <feather-icon
                          size="18"
                          :icon="'SidebarIcon'"
                      />
                    </b-avatar> &nbsp;
                    <small>DÍAS TAREOS RANGO</small>
                  </b-media-aside>
                </b-media>
                <div
                    class="font-weight-bolder"
                    :class="'text-info'"
                >
                  {{valor_dias_tareo_rango_global}}
                </div>
              </div>
              <div
                  class="transaction-item"
              >
                <b-media no-body>
                  <b-media-aside>
                    <b-avatar
                        rounded
                        size="42"
                        :variant="'light-warning'"
                    >
                      <feather-icon
                          size="18"
                          :icon="'ColumnsIcon'"
                      />
                    </b-avatar> &nbsp;
                    <small>DÍAS CANJEADO RANGO</small>
                  </b-media-aside>
                </b-media>
                <div
                    class="font-weight-bolder"
                    :class="'text-warning'"
                >
                  {{valor_canjeado_dias_rango_global}}
                </div>
              </div>

              <div
                  class="transaction-item"
              >
                <b-media no-body>
                  <b-media-aside>
                    <b-avatar
                        rounded
                        size="42"
                        :variant="'light-primary'"
                    >
                      <feather-icon
                          size="18"
                          :icon="'HashIcon'"
                      />
                    </b-avatar> &nbsp;
                    <small>DÍAS FALTA RANGO</small>
                  </b-media-aside>
                </b-media>
                <div
                    class="font-weight-bolder"
                    :class="'text-primary'"
                >
                  {{valor_dias_falta_rango_global}}
                </div>
              </div>
            </b-card-body>


          </b-card>

        </b-modal>
        <b-modal
            id="modalResumenCategoria"
            v-model="estadoModalResumenCategoria"
            :title="infoModal.titleResumenCategoria"
            hide-footer
            size="lg"
        >
          <b-card
              class="card-transaction"
              no-body
          >
            <b-card-header>
              <span>Personal por categorización</span>
              <b-dropdown
                  variant="link"
                  no-caret
                  class="chart-dropdown"
                  toggle-class="p-0"
                  right
              >
                <template #button-content>
                  <div>{{rango_fecha_resumen}}</div>
                </template>
              </b-dropdown>

            </b-card-header>
            <b-card-body>
              <b-table
                  hover
                  responsive
                  class="position-relative"
                  :items="itemsResumen"
                  :fields="fieldsResumen"
                  :busy="loading_res"
                  show-empty
                  empty-text="No se encontraron datos."
                  id="table-resumen"
                  foot-clone
              >
                <template #table-busy>
                  <div class="text-center text-dark my-1">
                    <b-spinner class="align-middle"></b-spinner> &emsp;
                    <strong>Obteniendo datos...</strong>
                  </div>
                </template>
                <template #cell(total_porcentaje)="data">
                  {{data.value}} %
                </template>
                <template #foot()="data" >
                  <i v-if="data.label == 'CATEGORIA'"><b class="text-dark">TOTAL</b></i>
                  <i v-if="data.label == 'NUEVOS'"><b class="text-warning">{{ total_personal_nuevo }}</b></i>
                  <i v-if="data.label == 'ANTIGUOS'"><b class="text-warning">{{ total_personal_antiguo }}</b></i>
                  <i v-if="data.label == 'TOTAL'"><b class="text-warning">{{ total_personal_categ }}</b></i>
                  <i v-if="data.label == 'PORCENTAJE'"><b class="text-warning">{{ total_personal_total_porcentaje }} %</b></i>
                </template>

              </b-table>
            </b-card-body>


          </b-card>

        </b-modal>


      </div>

    </b-card>



  </div>


</template>

<script>
import axiosIns from '../../../libs/axios'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import flatPickr from 'vue-flatpickr-component'
import { BFormCheckbox, BCardText } from 'bootstrap-vue'
import { Spanish } from 'flatpickr/dist/l10n/es.js'
import { VueGoodTable } from 'vue-good-table'
import "vue-good-table/dist/vue-good-table.css";
import store from '@/store/index'
import VueApexCharts from 'vue-apexcharts'
import apexChatData from './apexChartData'

import * as am5 from '@amcharts/amcharts5';
import * as am5xy from '@amcharts/amcharts5/xy';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';
import { useToggle } from '@vueuse/core'



import {
  BCard,
  BTable,
  BAvatar,
  BBadge,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCardBody,
  BTooltip,
  BModal,
  VBModal,
  BListGroup,
  BListGroupItem,
  BRow,
  BCol, BSpinner,
  BDropdown, BDropdownItem,
  BCardHeader, BCardTitle, BCardSubTitle,
  Card,  BFormFile, BFormTextarea, BButtonGroup, BSidebar,
  VBToggle, BForm, BFormDatepicker, BLink, BInputGroupPrepend, BDropdownForm, BDropdownHeader, BDropdownDivider,
  BFormRadio, BFormRadioGroup,
  BAlert,

} from 'bootstrap-vue'
import axios from 'axios'
import qs from 'qs'
import { Modal, Button } from 'bootstrap'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import VueContext from 'vue-context'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { heightFade } from '@core/directives/animations'

export default {
  components: {
    BCard,
    BTable,
    BAvatar,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BTooltip,
    BModal,
    VBModal,
    BListGroup,
    BListGroupItem,
    BRow,
    BCol,
    vSelect,
    ToastificationContent,
    BSpinner,
    flatPickr,
    BFormCheckbox,
    BCardText,
    VueGoodTable,
    BDropdown,
    BDropdownItem,
    VueApexCharts,
    BCardHeader,
    BCardTitle,
    BCardSubTitle,
    apexchart: VueApexCharts,
    Modal,
    ValidationProvider,
    ValidationObserver,
    VueContext,
    BLink,
    BFormFile,
    BFormTextarea,
    BButtonGroup,
    BSidebar,
    BFormDatepicker,
    BInputGroupPrepend,
    BForm,
    BDropdownForm,
    BDropdownHeader,
    BDropdownDivider,
    BFormRadio,
    BFormRadioGroup,
    BAlert,
    useToggle
  },
  directives: {
    'b-modal': VBModal,
    'modal': Modal,
    'height-fade': heightFade,
    Ripple,
  },
  data() {
    return {

      perPage: 10,
      pageOptions: [5, 10, 15],
      totalRows: 1,
      currentPage: 1,
      sortBy: 'id',
      sortDesc: false,
      sortByTable: "nombres_trabajador",
      sortAscDesc:"asc",
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      perPage_c: 10,
      pageOptions_c: [5, 10, 15],
      totalRowsTareos: 1,
      currentPage_c: 1,
      sortBy_c: '',
      sortDesc_c: false,
      sortDirection_c: 'asc',
      filter_tareo: null,
      filterOnTareos: [],
      loading_c: false,
      loading_res:false,
      estadoModal: false,
      showRangeFecha: true,
      showFecha: true,
      show: false,
      estadoModalEstadistica:false,
      src: '',
      estadoGrafico:false,
      estadoModalResumenCategoria:false,
      infoModal: {
        title: '',
        boton: '',
        titleEstadistica:'',
        titleAsistencia:'',
        titleasistenciaRangoText:'',
        titleasistenciaRangoTextGlobal:'',
        titleResumenCategoria:'',
      },
      fields: [],
      items: [],
      itemsResumen: [],
      itemsResumenSS: [
        { Categoría: 'Malos 2', Nuevos: 1, Antiguos: 1, Total: 12, Porcentaje: 12 },
        { Categoría: 'Malos 1', Nuevos: 1, Antiguos: 1, Total: 12 ,Porcentaje: 12 },
        { Categoría: 'Regulares 2', Nuevos: 1, Antiguos: 1, Total: 12,Porcentaje: 12  },
        { Categoría: 'Regulares 1', Nuevos: 1, Antiguos: 1, Total: 12,Porcentaje: 12  },
        { Categoría: 'Buenos', Nuevos: 1, Antiguos: 1, Total: 12,Porcentaje: 12  },
        { Categoría: 'Muy Buenos', Nuevos: 1, Antiguos: 1, Total: 12,Porcentaje: 12  },
        { Categoría: 'Top Workers', Nuevos: 1, Antiguos: 1, Total: 12,Porcentaje: 12  },
        { Categoría: 'Totales', Nuevos: 1, Antiguos: 1, Total: 12,Porcentaje: 12,
          _cellVariants: { Categoría: 'info', Nuevos: 'warning',Antiguos: 'warning',Total: 'warning',Porcentaje: 'warning' },

        }
      ],
      fieldsTareos: [
        {
          key: 'fecha_tareo',
          label: 'FECHA',
          sortable: true
        },
        {
          key: 'cumplimiento_cuadrilla',
          label: 'cumplimiento',
          sortable: true
        },
        {
          key: 'categoria_rango',
          label: 'categoría',
        },
      ],
      fieldsResumen: [
        {
          key: 'categoria_rango',
          label: 'CATEGORIA',
          sortable: false,
          variant: 'info',
          // thClass: 'bg-white text-dark'
        },
        {
          key: 'nuevos',
          label: 'NUEVOS',
          sortable: false
        },
        {
          key: 'antiguos',
          label: 'ANTIGUOS',
          sortable: false
        },
        {
          key: 'total',
          label: 'TOTAL',
          sortable: false
        },
        {
          key: 'total_porcentaje',
          label: 'PORCENTAJE',
          sortable: false
        },
      ],
      loading: false,
      tipoOptionsSelected: null,
      tipoOptions: [
        {
          value: '0',
          text: 'FECHA ESPECIFICA'
        },
        {
          value: '1',
          text: 'RANGO FECHA'
        }
      ],
      valor_maximo_rango:'',
      valor_minimo_rango:'',
      valor_estandar_rango:'',
      fechaSelect: '',
      rangeDate: null,
      rangeDateFil: null,

      estadoCosechaSelected: 'NUEVO',
      estadoCosecha: [
        {
          value: 'NUEVO',
          text: 'NUEVO'
        },
        {
          value: 'ANTIGUO',
          text: 'ANTIGUO'
        },
        {
          value: 'T',
          text: 'TODOS'
        }
      ],

      fechaCorteSelect: null,
      condicion: '60',
      itemsTareos: [],
      nombres_trabajador: 'luis',
      promedio_simples: '',
      selected: [],

      status: [
        {
          1: 'Nuevo',
          2: 'Antiguo',
          3: 'Sin contrato',
        },
        {
          1: 'light-success',
          2: 'light-warning',
          3: 'light-danger',
        }
      ],
      darBFechaCorte: '',
      darBFechaInicial: '',
      darBFechaFinal: '',
      darBCondicion: '',
      categoriaSelected: ['TODOS'],
      optcategoria: [
        {value: 'MALOS 2', text: "MALOS 2"},
        {value: 'MALOS 1', text: "MALOS 1"},
        {value: 'REGULARES 2', text: "REGULARES 2"},
        {value: 'REGULARES 1', text: "REGULARES 1"},
        {value: 'BUENOS', text: "BUENOS"},
        {value: 'MUY BUENOS', text: "MUY BUENOS"},
        {value: 'TOP WORKERS', text: "TOP WORKERS"},
        {value: 'TODOS', text: "TODOS"},

      ],

      pageLength: 10,
      dir: false,
      columns: [
        {
          label: 'EMPRESA',
          field: 'nombre_empresa',
          sortable: false,
        },
        {
          label: 'DNI',
          field: 'dni_trabajador',
          sortable: false,
        },
        {
          label: 'TRABAJADOR',
          field: 'nombres_trabajador',
          //filterOptions: {
          //enabled: true,
          //customFilter: true,
          //placeholder: 'TRABAJADOR'
          //}
          sortable: false,
          //firstSortType: 'desc',
          //thClass: 'custom-th-class text-center',
          tdClass: 'text-left',
          //tooltip: 'A simple tooltip',
          // hidden: true,
        },
        {
          label: 'FECHA INGRESO',
          field: 'fecha_penultima_contrato',
          //type: 'date',
          //dateInputFormat: 'yyyy-MM-dd',
          //dateOutputFormat: 'dd/MM/yyyy',
          sortable: false,

        },
        {
          label: 'FECHA REINGRESO',
          field: 'fecha_reingreso',
          sortable: false,
          type: 'text',
        },

        {
          label: 'DIAS CONTRATO RANGO',
          field: 'dias_contrato_rango',
          sortable: false,
          type: 'number',
        },
        {
          label: 'FECHA RANGO INICIAL',
          field: 'fecha_inicial_char',
          sortable: false,
        },
        {
          label: 'FECHA RANGO FINAL',
          field: 'fecha_final_char',
          sortable: false,
        },
        {
          label: 'TOTAL TAREO RANGO',
          field: 'total_labores_rango',
          type: 'number',
          sortable: false,
          tdClass: 'text-center',
        },
        {
          label: 'DÍAS LABORES RANGO',
          field: 'total_otras_labores_rango',
          type: 'number',
          sortable: false,
        },
        {
          label: 'DÍAS COSECHA RANGO',
          field: 'nro_dias_cosecha_rango',
          sortable: false,
          type: 'number',
          tooltip: 'A simple tooltip',
        },
        {
          label: 'JABAS RANGO',
          field: 'jaba_total_rango',
          sortable: false,
          type: 'number',
        },
        {
          label: '% DÍAS COSECHA RANGO',
          field: 'porcentaje_dia_cosecha',
          sortable: false,
          type: 'percentage',
        },
        {
          label: '% COSECHA HISTORICO',
          field: 'porcentaje_dia_cosecha_historico',
          sortable: false,
          type: 'percentage',
        },
        {
          label: 'CONDICIÓN MAYOR A',
          field: 'resultado_condicion_rango_redondeo',
          sortable: false,
          type: 'percentage',
        },
        {
          label: 'PROMEDIO CUMPLIMIENTO RANGO',
          field: 'promedio_cumplimiento_cuadrilla_rango_redondeo',
          sortable: false,
          type: 'percentage',//
        },
        {
          label: 'CUMPLIMIENTO CAMPAÑA ANTERIOR',
          field: 'prom_campania_anterior_rango_redondeo',
          sortable: false,
          type: 'percentage',//prom_campania_anterior_rango
        },
        {
          label: 'CATEGORÍA RANGO',
          field: 'categoria_rango',
          sortable: false,
          firstSortType: 'asc',

        },

        {
          label: '% ASISTENCIA RANGO',
          field: 'porcentaje_asistencia_rango',
          sortable: false,
          type: 'percentage',
        },
        {
          label: 'ASIS. 5 DÍAS RANGO',
          field: 'porcentaje_asistencia_rango_asistencia_global_final',
          sortable: false,
          type: 'percentage',
        },

        {
          label: 'PROMEDIO R1 RANGO',
          field: 'promedio_cumplimiento_cuadrilla_rango_redondeo_r1',
          sortable: true,
          type: 'percentage',
        },
        {
          label: 'PROMEDIO R2 RANGO',
          field: 'promedio_cumplimiento_cuadrilla_rango_redondeo_r2',
          sortable: false,
          type: 'percentage',
        },
        {
          label: 'PROMEDIO APRENDIZAJE RANGO',
          field: 'promedio_aprendizaje',
          sortable: false,
          type: 'percentage',
        },

        {
          label: 'CÁLCULO',
          field: 'calculado',
          sortable: false,
          type: 'percentage',
        },
        {
          label: 'ESTADO OBSERVADO',
          field: 'estado_proceso_observados',
          sortable: false,

        },
        {
          label: 'ESTADO COSECHA',
          field: 'estado_cosecha',
          sortable: false,
        },
        {
          label: 'EXCLUIDO',
          field: 'excluido',
          sortable: false,
        },



      ],
      rowsBajaProductividad: [],
      rowsBajaProductividadInput: [],
      searchTerm: '',
      shippingprogramFiltro:[],
      optionList: [
        {
          nombre_empresa: 'Joan',
          dni_trabajador: 1
        },
        {
          nombre_empresa: 'Don',
          dni_trabajador: 2
        }
      ],
      shift: '',
      rowSelection: [],
      rowObjSelectionData:{},
      filterDropdown:[],
      estadoModalAsistencia : false,
      estadoModalasistenciaRangoText : false,
      estadoModalasistenciaRangoTextGlobal : false,
      valor_total_asis : '',
      valor_otra_labor_asis : '',
      valor_cosecha_asis : '',
      valor_falta_asis : '',
      valor_dias_empresa:'',
      valor_operativo_rango : '',
      valor_canjeado_dias : '',
      valor_dias_falta_rango : '',
      valor_dias_tareo_rango:'',
      valor_operativo_rango_global : '',
      valor_dias_falta_rango_global : '',
      valor_dias_tareo_rango_global:'',
      valor_canjeado_dias_rango_global: '',
      contadorRoot:0,
      root:null,
      dataGrafico:[],

      rowsBajaProductividadFiltro: [],
      filtroCabeceraTable: [
        {nombre: "nombre_empresa",valor: [],tipo:"string",condicional:"="},
        {nombre: "dni_trabajador",valor: [],tipo:"string",condicional:"="},
        {nombre: "nombres_trabajador",valor: [],tipo:"string",condicional:"="},
        {nombre: "fecha_penultima_contrato",valor: [],tipo:"string",condicional:"="},
        {nombre: "fecha_reingreso",valor: [],tipo:"string",condicional:"="},
        {nombre: "fecha_inicial_char",valor: [],tipo:"string",condicional:"="},
        {nombre: "fecha_final_char",valor: [],tipo:"string",condicional:"="},
        {nombre: "porcentaje_dia_cosecha",valor: [],tipo:"float",condicional:"="},
        {nombre: "porcentaje_dia_cosecha_historico",valor: [],tipo:"float",condicional:"="},
        {nombre: "porcentaje_asistencia_rango", valor: [],tipo:"float",condicional:"="},
        {nombre: "porcentaje_asistencia_rango_asistencia_global_final", valor: [],tipo:"float",condicional:"="},
        {nombre: "promedio_aprendizaje", valor: [],tipo:"float",condicional:"="},
        {nombre: "dias_contrato_rango", valor: [],tipo:"float",condicional:"="},
        {nombre: "total_labores_rango", valor: [],tipo:"float",condicional:"="},
        {nombre: "total_otras_labores_rango", valor: [],tipo:"float",condicional:"="},
        {nombre: "nro_dias_cosecha_rango", valor: [],tipo:"float",condicional:"="},
        {nombre: "jaba_total_rango", valor: [],tipo:"float",condicional:"="},
        {nombre: "categoria_rango", valor: [],tipo:"string",condicional:"="},
        {nombre: "estado_proceso_observados", valor: [],tipo:"string",condicional:"="},
        {nombre: "estado_cosecha", valor: [],tipo:"string",condicional:"="},
        {nombre: "excluido", valor: [],tipo:"string",condicional:"="},
        {nombre: "resultado_condicion_rango_redondeo", valor: [],tipo:"float",condicional:"="},
        {nombre: "promedio_cumplimiento_cuadrilla_rango_redondeo", valor: [],tipo:"float",condicional:"="},
        {nombre: "prom_campania_anterior_rango_redondeo", valor: [],tipo:"float",condicional:"="},
        {nombre: "promedio_cumplimiento_cuadrilla_rango_redondeo_r1", valor: [],tipo:"float",condicional:"="},
        {nombre: "promedio_cumplimiento_cuadrilla_rango_redondeo_r2", valor: [],tipo:"float",condicional:"="},
        {nombre: "calculado", valor: [],tipo:"float",condicional:"="},

      ],
      estadoFiltroCabeceraTable: false,
      asistenciaRangoText:'',
      diasCtoRangoText:'',
      diasAsistenciaRangoText:'',
      mediaAprendizajeRangoText:'',
      empresaFiltroCabeceraTableSelected:[],
      empresaFiltroCabeceraTableOpciones:[],
      dniTrabajadorFiltroCabeceraTableSelected:[],
      dniTrabajadorFiltroCabeceraTableOpciones:[],
      trabajadorFiltroCabeceraTableSelected:[],
      trabajadorFiltroCabeceraTableOpciones:[],
      fechaUlIngresoFiltroCabeceraTableSelected:[],
      fechaUlIngresoFiltroCabeceraTableOpciones:[],
      fechaInicialRangoFiltroCabeceraTableSelected:[],
      fechaInicialRangoFiltroCabeceraTableOpciones:[],
      fechaFinalRangoFiltroCabeceraTableSelected:[],
      fechaFinalRangoFiltroCabeceraTableOpciones:[],
      cosechaHistoricoFiltroCabeceraTableSelected:[],
      cosechaHistoricoFiltroCabeceraTableOpciones:[],
      cosechaHistoricoText:'',
      asistenciaFiltroCabeceraTableSelected:[],
      asistenciaFiltroCabeceraTableOpciones:[],
      diasCtoRangoFiltroCabeceraTableSelected:[],
      diasCtoRangoFiltroCabeceraTableOpciones:[],
      diasAsistenciaFiltroCabeceraTableSelected:[],
      diasAsistenciaFiltroCabeceraTableOpciones:[],
      cosechaRangoText:'',
      cosechaRangoFiltroCabeceraTableSelected:[],
      cosechaRangoFiltroCabeceraTableOpciones:[],
      fechaReingresoFiltroCabeceraTableSelected:[],
      fechaReingresoFiltroCabeceraTableOpciones:[],
      mediaAprendizajeFiltroCabeceraTableOpciones:[],
      mediaAprendizajeFiltroCabeceraTableSelected:[],
      totalTareoRangoFiltroCabeceraTableSelected:[],
      totalTareoRangoFiltroCabeceraTableOpciones:[],
      totalOtraLaborRangoFiltroCabeceraTableSelected:[],
      totalOtraLaborRangoFiltroCabeceraTableOpciones:[],
      diasCosechaRangoFiltroCabeceraTableSelected:[],
      diasCosechaRangoFiltroCabeceraTableOpciones:[],
      jabaTotalRangoFiltroCabeceraTableSelected:[],
      jabaTotalRangoFiltroCabeceraTableOpciones:[],
      categoriaRangoFiltroCabeceraTableSelected:[],
      categoriaRangoFiltroCabeceraTableOpciones:[],
      estadoProObservadosFiltroCabeceraTableSelected:[],
      estadoProObservadosFiltroCabeceraTableOpciones:[],
      estadoCosechaFiltroCabeceraTableSelected:[],
      estadoCosechaFiltroCabeceraTableOpciones:[],
      excluidoFiltroCabeceraTableSelected:[],
      excluidoFiltroCabeceraTableOpciones:[],

      condicionalSelectedAsistencia: '=',
      condicionalSelectedDiasCtoRango: '=',
      condicionalSelectedDiasAsistencia: '=',
      condicionalSelectedMediaAprendizaje: '=',
      condicionalSelectedCosHistorico: '=',
      condicionalSelectedCosRango: '=',
      condicionaOptionsAsistencia: [
        { text: 'Igual', value: '=' },
        { text: 'Mayor o Igual', value: '>=' },
        { text: 'Menor o Igual', value: '<=' },
      ],
      condicionaOptionsDiasCtoRango: [
        { text: 'Igual', value: '=' },
        { text: 'Mayor o Igual', value: '>=' },
        { text: 'Menor o Igual', value: '<=' },
      ],
      condicionaOptionsDiasAsistencia: [
        { text: 'Igual', value: '=' },
        { text: 'Mayor o Igual', value: '>=' },
        { text: 'Menor o Igual', value: '<=' },
      ],
      condicionaOptionsMediaAprendizaje: [
        { text: 'Igual', value: '=' },
        { text: 'Mayor o Igual', value: '>=' },
        { text: 'Menor o Igual', value: '<=' },
      ],
      condicionaOptionsCosHistorico: [
        { text: 'Igual', value: '=' },
        { text: 'Mayor o Igual', value: '>=' },
        { text: 'Menor o Igual', value: '<=' },
      ],
      condicionaOptionsCosRango: [
        { text: 'Igual', value: '=' },
        { text: 'Mayor o Igual', value: '>=' },
        { text: 'Menor o Igual', value: '<=' },
      ],
      dismissSecs: 5,
      dismissCountDown: 0,
      dismissSecsDiasAsistencia: 5,
      dismissCountDownDiasAsistencia: 0,
      dismissSecsDiasCtoRango: 5,
      dismissCountDownDiasCtoRango:0,
      dismissSecsCosRango: 5,
      dismissCountDownCosRango: 0,
      dismissSecsCosHistorico: 5,
      dismissCountDownCosHistorico: 0,
      dismissSecsMediaAprendizaje: 5,
      dismissCountDownMediaAprendizaje: 0,
      filterTable: null,
      operadorSelected:">=",
      optOperador:[
        { text: 'Igual', value: '=' },
        { text: 'Mayor o Igual', value: '>=' },
        { text: 'Menor o Igual', value: '<=' },
      ],
      totalTareoRangoText:'',
      condicionalSelectedtotalTareoRango: '=',
      condicionaOptionsTotalTareoRango: [
        { text: 'Igual', value: '=' },
        { text: 'Mayor o Igual', value: '>=' },
        { text: 'Menor o Igual', value: '<=' },
      ],
      dismissSecsTotalTareoRango: 5,
      dismissCountDownTotalTareoRango:0,

      totalOtraLaborRangoText:'',
      condicionalSelectedtotalOtraLaborRango: '=',
      condicionaOptionstotalOtraLaborRango: [
        { text: 'Igual', value: '=' },
        { text: 'Mayor o Igual', value: '>=' },
        { text: 'Menor o Igual', value: '<=' },
      ],
      dismissSecstotalOtraLaborRango: 5,
      dismissCountDowntotalOtraLaborRango:0,

      diasCosechaRangoText:'',
      condicionalSelecteddiasCosechaRango: '=',
      condicionaOptionsdiasCosecharRango: [
        { text: 'Igual', value: '=' },
        { text: 'Mayor o Igual', value: '>=' },
        { text: 'Menor o Igual', value: '<=' },
      ],
      dismissSecsdiasCosechaRango: 5,
      dismissCountDowndiasCosechaRango:0,


      jabaTotalRangoText:'',
      condicionalSelectedjabaTotalRango: '=',
      condicionaOptionsjabaTotalRango: [
        { text: 'Igual', value: '=' },
        { text: 'Mayor o Igual', value: '>=' },
        { text: 'Menor o Igual', value: '<=' },
      ],
      dismissSecsjabaTotalRango: 5,
      dismissCountDownjabaTotalRango:0,
      cumplimientoText:"0",
      isThema:true,
      isThemaPage_dia:"table-format tablita",
      isThemaPage_noche:"table-format-noche tablita",
      dark: localStorage.getItem('theme'),
      numeroPaguinaActual:1,
      ultimoDiaAsistencia:'5',
      loading_exp: false,
      rango_fecha_resumen:'',
      total_personal_categ:0,
      total_personal_nuevo:0,
      total_personal_antiguo:0,
      total_personal_total_porcentaje:0,
      resultadoCondicionRangoFiltroCabeceraTableSelected:[],
      resultadoCondicionRangoFiltroCabeceraTableOpciones:[],

      resultadoCondicionRangoText:'',
      condicionalSelectedresultadoCondicionRango: '=',
      condicionaOptionsresultadoCondicionRango: [
        { text: 'Igual', value: '=' },
        { text: 'Mayor o Igual', value: '>=' },
        { text: 'Menor o Igual', value: '<=' },
      ],
      dismissSecsresultadoCondicionRango: 5,
      dismissCountDownresultadoCondicionRango:0,
      promedioCumplimientoRangoFiltroCabeceraTableSelected:[],
      promedioCumplimientoRangoFiltroCabeceraTableOpciones:[],
      promedioCumplimientoCampAnteriorRangoFiltroCabeceraTableSelected:[],
      promedioCumplimientoCampAnteriorRangoFiltroCabeceraTableOpciones:[],

      promedioCumplimientoRangoText:'',
      condicionalSelectedpromedioCumplimientoRango: '=',
      condicionaOptionspromedioCumplimientoRango: [
        { text: 'Igual', value: '=' },
        { text: 'Mayor o Igual', value: '>=' },
        { text: 'Menor o Igual', value: '<=' },
      ],
      dismissSecspromedioCumplimientoRango: 5,
      dismissCountDownpromedioCumplimientoRango:0,

      promedioCumplimientoCampAnteriorRangoText:'',
      condicionalSelectedpromedioCumplimientoCampAnteriorRango: '=',
      condicionaOptionspromedioCumplimientoCampAnteriorRango: [
        { text: 'Igual', value: '=' },
        { text: 'Mayor o Igual', value: '>=' },
        { text: 'Menor o Igual', value: '<=' },
      ],
      dismissSecspromedioCumplimientoCampAnteriorRango: 5,
      dismissCountDownpromedioCumplimientoCampAnteriorRango:0,

      promedioCumplimientoR1RangoFiltroCabeceraTableSelected:[],
      promedioCumplimientoR1FiltroCabeceraTableOpciones:[],


      promedioCumplimientoR1RangoText:'',
      condicionalSelectedpromedioCumplimientoR1Rango: '=',
      condicionaOptionspromedioCumplimientoR1Rango: [
        { text: 'Igual', value: '=' },
        { text: 'Mayor o Igual', value: '>=' },
        { text: 'Menor o Igual', value: '<=' },
      ],
      dismissSecspromedioCumplimientoR1Rango: 5,
      dismissCountDownpromedioCumplimientoR1Rango:0,

      promedioCumplimientoR2RangoFiltroCabeceraTableSelected:[],
      promedioCumplimientoR2RangoFiltroCabeceraTableOpciones:[],

      promedioCumplimientoR2RangoText:'',
      condicionalSelectedpromedioCumplimientoR2Rango: '=',
      condicionaOptionspromedioCumplimientoR2Rango: [
        { text: 'Igual', value: '=' },
        { text: 'Mayor o Igual', value: '>=' },
        { text: 'Menor o Igual', value: '<=' },
      ],
      dismissSecspromedioCumplimientoR2Rango: 5,
      dismissCountDownpromedioCumplimientoR2Rango:0,
      calculadoRangoFiltroCabeceraTableSelected:[],
      calculadoRangoFiltroCabeceraTableOpciones:[],
      calculadoRangoText:'',
      condicionalSelectedcalculadoRango: '=',
      condicionaOptionscalculadoRango: [
        { text: 'Igual', value: '=' },
        { text: 'Mayor o Igual', value: '>=' },
        { text: 'Menor o Igual', value: '<=' },
      ],
      dismissSecscalculadoRango: 5,
      dismissCountDowncalculadoRango:0,
      existe_excluido : "",
    }
  },
  props: ['sometext'],
  computed: {

    sortOptions() {
      // Create an options list from our fields
      return this.fields
          .filter(f => f.sortable)
          .map(f => ({
            text: f.label,
            value: f.key
          }))
    },
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Current: 'light-primary',
        Professional: 'light-success',
        Rejected: 'light-danger',
        Resigned: 'light-warning',
        Applied: 'light-info',
        /* eslint-enable key-spacing */
      }

      return status => statusColor[status]
    },
    statusCosecha() {
      const statusColor = {
        /* eslint-disable key-spacing */
        'NUEVO': 'light-success',
        'ANTIGUO': 'light-warning',
        /* eslint-enable key-spacing */
      }

      return status => statusColor[status]
    },
    salidaCosecha() {
      const salidaCosecha = {
        /* eslint-disable key-spacing */
        1: 'NUEVO',
        2: 'ANTIGUO',
        3: 'Sin contrato',
        /* eslint-enable key-spacing */
      }

      return status => salidaCosecha[status]
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },

  },
  mounted() {


    this.inicializacion()
    this.validadEntradaRangeFiltro('1','LF')

  },
  methods: {
    listarBajaProductividad(fecha_inicial, fecha_final, fecha_corte) {
      var yo = this


      yo.loading = true

      yo.darBFechaInicial = fecha_inicial
      yo.darBFechaFinal = fecha_final
      yo.darBFechaCorte = fecha_corte
      yo.darBCondicion = yo.condicion

      var categorias = '';

      var cteTodos = "";
      if(yo.categoriaSelected.length>0){
        for(const value of yo.categoriaSelected){

          categorias = categorias + "'"+value+"'"
          if(value == "TODOS"){

            yo.categoriaSelected = ['TODOS'];
            //categorias =
            break;
          }
        }
      }
      var categoriasSeleccionadas = categorias.replaceAll("''",",").replaceAll("'","");


      yo.rowsBajaProductividad = [];
      yo.rowsBajaProductividadFiltro = [];
      var body = '' +
          'fecha_corte=' + fecha_corte + '&' +
          'fecha_inicial=' + fecha_inicial + '&' +
          'fecha_final=' + fecha_final + '&' +
          'estado_cosecha=' + yo.estadoCosechaSelected + '&' +
          'categoria_rango=' + categoriasSeleccionadas + '&' +
          'condicion=' + yo.condicion + '&' +
          'cumplimiento=' + yo.cumplimientoText + '&' +
          'regla_cumplimiento=' + yo.operadorSelected + '&' +
          'dia_asistencia_global=' + yo.ultimoDiaAsistencia
      ''


      var config = {
        method: 'get',
        url: '/cosecha/cosecha/leer/dar/baja/trabajador/?' + body,
        headers: {}
      }

      axiosIns(config)
          .then((response) => {
            yo.rowsBajaProductividad = response.data.respuesta;
            yo.rowsBajaProductividadInput = response.data.inputs;
            yo.totalRows = yo.rowsBajaProductividad.length
            yo.rowsBajaProductividadFiltro = yo.rowsBajaProductividad

            for (let value of yo.rowsBajaProductividad){


              if (value.nombre_empresa != null && value.nombre_empresa !== '' && value.nombre_empresa !== ' ' && value.nombre_empresa !== '  ')
              {
                yo.empresaFiltroCabeceraTableOpciones.push(value.nombre_empresa)
              }
              if (value.nombres_trabajador != null && value.nombres_trabajador !== '' && value.nombres_trabajador !== ' ' && value.nombres_trabajador !== '  ')
              {
                yo.trabajadorFiltroCabeceraTableOpciones.push(value.nombres_trabajador)
              }
              if (value.dni_trabajador != null && value.dni_trabajador !== '' && value.dni_trabajador !== ' ' && value.dni_trabajador !== '  ')
              {
                yo.dniTrabajadorFiltroCabeceraTableOpciones.push(value.dni_trabajador)
              }
              if (value.fecha_penultima_contrato != null && value.fecha_penultima_contrato !== '' && value.fecha_penultima_contrato !== ' ' && value.fecha_penultima_contrato !== '  ')
              {
                yo.fechaUlIngresoFiltroCabeceraTableOpciones.push(value.fecha_penultima_contrato)
              }
              if (value.fecha_reingreso != null && value.fecha_reingreso !== '' && value.fecha_reingreso !== ' ' && value.fecha_reingreso !== '  ')
              {
                yo.fechaReingresoFiltroCabeceraTableOpciones.push(value.fecha_reingreso)
              }
              if (value.fecha_inicial_char != null && value.fecha_inicial_char !== '' && value.fecha_inicial_char !== ' ' && value.fecha_inicial_char !== '  ')
              {
                yo.fechaInicialRangoFiltroCabeceraTableOpciones.push(value.fecha_inicial_char)
              }
              if (value.fecha_final_char != null && value.fecha_final_char !== '' && value.fecha_final_char !== ' ' && value.fecha_final_char !== '  ')
              {
                yo.fechaFinalRangoFiltroCabeceraTableOpciones.push(value.fecha_final_char)
              }
              if (value.categoria_rango != null && value.categoria_rango !== '' && value.categoria_rango !== ' ' && value.categoria_rango !== '  ')
              {
                yo.categoriaRangoFiltroCabeceraTableOpciones.push(value.categoria_rango)
              }
              if (value.estado_proceso_observados != null && value.estado_proceso_observados !== '' && value.estado_proceso_observados !== ' ' && value.estado_proceso_observados !== '  ')
              {
                yo.estadoProObservadosFiltroCabeceraTableOpciones.push(value.estado_proceso_observados)
              }
              if (value.estado_cosecha != null && value.estado_cosecha !== '' && value.estado_cosecha !== ' ' && value.estado_cosecha !== '  ')
              {
                yo.estadoCosechaFiltroCabeceraTableOpciones.push(value.estado_cosecha)
              }
              if (value.excluido != null && value.excluido !== '' && value.excluido !== ' ' && value.excluido !== '  ')
              {
                yo.excluidoFiltroCabeceraTableOpciones.push(value.excluido)
              }
            }
            //yo.fechaReingresoFiltroCabeceraTableOpciones.push('VACIOS')
            yo.dni_trabajador = [... new Set(yo.dni_trabajador)];
            yo.trabajadorFiltroCabeceraTableOpciones = [... new Set(yo.trabajadorFiltroCabeceraTableOpciones)];
            yo.fechaUlIngresoFiltroCabeceraTableOpciones = [... new Set(yo.fechaUlIngresoFiltroCabeceraTableOpciones)];
            yo.fechaReingresoFiltroCabeceraTableOpciones = [... new Set(yo.fechaReingresoFiltroCabeceraTableOpciones)];
            yo.empresaFiltroCabeceraTableOpciones = [... new Set(yo.empresaFiltroCabeceraTableOpciones)];
            yo.fechaInicialRangoFiltroCabeceraTableOpciones = [... new Set(yo.fechaInicialRangoFiltroCabeceraTableOpciones)];
            yo.fechaFinalRangoFiltroCabeceraTableOpciones = [... new Set(yo.fechaFinalRangoFiltroCabeceraTableOpciones)];
            yo.categoriaRangoFiltroCabeceraTableOpciones = [... new Set(yo.categoriaRangoFiltroCabeceraTableOpciones)];
            yo.estadoProObservadosFiltroCabeceraTableOpciones = [... new Set(yo.estadoProObservadosFiltroCabeceraTableOpciones)];
            yo.estadoCosechaFiltroCabeceraTableOpciones = [... new Set(yo.estadoCosechaFiltroCabeceraTableOpciones)];
            yo.excluidoFiltroCabeceraTableOpciones = [... new Set(yo.excluidoFiltroCabeceraTableOpciones)];

            yo.realizarFiltroCabeceraTable('--','--','--');



          })
          .catch(function (error) {
            console.log(error)
          })
          .finally(function () {
            yo.loading = false
          })

    },
    addHoursToDate(objDate, intHours) {
      var numberOfMlSeconds = objDate.getTime()
      var addMlSeconds = (intHours * 60) * 60000
      var newDateObj = new Date(numberOfMlSeconds + addMlSeconds)

      return newDateObj
    },
    validadEntradaRangeFiltro(tipo,filter) {
      const yo = this
      let fechaRangeTareo = yo.rangeDateFil
      let fechaInicioRange = ''
      let fechaFinRange = ''

      if (fechaRangeTareo == null || fechaRangeTareo == '') {

        if (tipo == '1') {

          let date_Actual = new Date()
          let date_inicial = yo.addHoursToDate(date_Actual, -168)
          let date_final = yo.addHoursToDate(date_Actual, -24)
          var fecha_inicial = date_inicial.getFullYear() + '-' + String(date_inicial.getMonth() + 1)
              .padStart(2, '0') + '-' + String(date_inicial.getDate())
              .padStart(2, '0')
          var fecha_final = date_final.getFullYear() + '-' + String(date_final.getMonth() + 1)
              .padStart(2, '0') + '-' + String(date_final.getDate())
              .padStart(2, '0')
          var fecha_inicial_f = String(date_inicial.getDate())
              .padStart(2, '0') + '/' + String(date_inicial.getMonth() + 1)
              .padStart(2, '0') + '/' + date_inicial.getFullYear()
          var fecha_final_f = String(date_final.getDate())
              .padStart(2, '0') + '/' + String(date_final.getMonth() + 1)
              .padStart(2, '0') + '/' + date_final.getFullYear()
          this.rangeDateFil = [fecha_inicial_f, fecha_final_f]
          fechaInicioRange = fecha_inicial
          fechaFinRange = fecha_final
          var fecha_corte_seleccionada = ''
          if (yo.fechaCorteSelect == '' || yo.fechaCorteSelect == null) {

            let date_Actual = new Date()
            let date = yo.addHoursToDate(date_Actual, -24)
            fecha_corte_seleccionada = date.getFullYear() + '-' + String(date.getMonth() + 1)
                .padStart(2, '0') + '-' + String(date.getDate())
                .padStart(2, '0')
            var fecha_corte_seleccionada_f = String(date.getDate())
                .padStart(2, '0') + '/' + String(date.getMonth() + 1)
                .padStart(2, '0') + '/' + date.getFullYear()
            yo.fechaCorteSelect = fecha_corte_seleccionada_f

          } else {
            var fecha_corte_inicial = yo.fechaCorteSelect
            var arrayFechaForecast = fecha_corte_inicial.toString()
                .split('/')
            fecha_corte_seleccionada = arrayFechaForecast[2] + '-' + arrayFechaForecast[1] + '-' + arrayFechaForecast[0]
          }
          yo.listarBajaProductividad(fechaInicioRange, fechaFinRange, fecha_corte_seleccionada)

        } else {

          yo.$swal.fire(
              'Mensaje',
              'Debe selecionar un rango fecha ',
              'warning'
          )
              .then((result) => {
              })
        }

      } else {

        if (yo.fechaCorteSelect == null || yo.fechaCorteSelect == '') {
          yo.$swal.fire(
              'Mensaje',
              'Debe selecionar una fecha de corte',
              'warning'
          )
              .then((result) => {
              })

          return
        } else if (fechaRangeTareo == null || fechaRangeTareo == '') {
          yo.$swal.fire(
              'Mensaje',
              'Debe selecionar un rango fecha',
              'warning'
          )
              .then((result) => {
              })

          return
        } else if (yo.condicion == null || yo.condicion == '') {
          yo.$swal.fire(
              'Mensaje',
              'Debe Ingresar una condición',
              'warning'
          )
              .then((result) => {
              })

          return
        }
        else if (yo.categoriaSelected.length<=0) {
          yo.$swal.fire(
              'Mensaje',
              'Debe seleccionar una categoría',
              'warning'
          )
              .then((result) => {
              })

          return
        }

        var fecha_corte_inicial = yo.fechaCorteSelect
        var arrayFechaForecast = fecha_corte_inicial.toString()
            .split('/')
        var fecha_corte_seleccionada = arrayFechaForecast[2] + '-' + arrayFechaForecast[1] + '-' + arrayFechaForecast[0]

        let fecha_array = fechaRangeTareo.split(' a ')

        if (fecha_array.length == 2) {
          let sep_feha_in = fecha_array[0].split('/')
          let sep_feha_fin = fecha_array[1].split('/')
          fechaInicioRange = sep_feha_in[2] + '-' + sep_feha_in[1] + '-' + sep_feha_in[0]
          fechaFinRange = sep_feha_fin[2] + '-' + sep_feha_fin[1] + '-' + sep_feha_fin[0]

          var day1Inicial = new Date(fechaInicioRange)
          var day2Final = new Date(fechaFinRange)
          var difference = Math.abs(day2Final - day1Inicial)
          var days = (difference / (1000 * 3600 * 24)) + 1
          if (days <= 16) {
            if(filter=='LF'){
              yo.listarBajaProductividad(fechaInicioRange, fechaFinRange, fecha_corte_seleccionada);
            }else {
              yo.verResumenCategoria(fechaInicioRange, fechaFinRange, fecha_corte_seleccionada);
            }

          } else {
            yo.$swal.fire(
                'Mensaje',
                'El rango de fecha seleccionado supera los 16 días!',
                'warning'
            )
                .then((result) => {
                })
          }
        } else {
          let sep_feha_in = fecha_array[0].split('/')
          fechaInicioRange = sep_feha_in[2] + '-' + sep_feha_in[1] + '-' + sep_feha_in[0]
          fechaFinRange = sep_feha_in[2] + '-' + sep_feha_in[1] + '-' + sep_feha_in[0]
          if(filter=='LF'){
            yo.listarBajaProductividad(fechaInicioRange, fechaFinRange, fecha_corte_seleccionada)
          }else {
            yo.verResumenCategoria(fechaInicioRange, fechaFinRange, fecha_corte_seleccionada);
          }

        }

      }

    },
    cPaginacion(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    inicializacion() {

      var yo = this
      let date_Actual = new Date()
      let date = yo.addHoursToDate(date_Actual, -24)
      var fecha_un_dia_antes = String(date.getDate())
          .padStart(2, '0') + '/' + String(date.getMonth() + 1)
          .padStart(2, '0') + '/' + date.getFullYear()
      yo.fechaCorteSelect = fecha_un_dia_antes
    },
    anularRegistro(dni, nombres) {

      var yo = this
      var icon = 'warning'
      var mensaje = ' dar de baja'
      var valorUpdate = '0'
      var mensajeSalida = 'Trabajador dado de baja'

      this.$swal({
        title: '¡Alerta!',
        text: '¿Seguro que quieres ' + mensaje + ' al trabajador ' + nombres + '?',
        icon: icon,
        showCancelButton: true,
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-danger',
        },
        buttonsStyling: false,
      })
          .then(result => {
            if (result.value) {

              this.$nextTick(() => {

                var yo = this

                var qs = require('qs')
                var data = qs.stringify({
                  'estado_dar_baja': '2',
                  'dni_trabajador': dni,
                })

                var config = {
                  method: 'post',
                  url: '/cosecha/cosecha/trabajadorNuevo/anular/',
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                  },
                  data: data
                }

                axiosIns(config)
                    .then(function (response) {
                      var res = response.data.respuesta
                      if (res == 'Exitoso') {
                        yo.$swal.fire(
                            'Dado de baja!',
                            'El trabajador ' + nombres + ' ha sido agregado a la lista negra correctamente',
                            'success'
                        )
                            .then((result) => {
                              yo.validadEntradaRangeFiltro('2','LF')
                            })
                      } else {
                        yo.$swal.fire(
                            'Dado de baja!',
                            'No se pudo dar de baja al trabajador!',
                            'info'
                        )
                            .then((result) => {
                            })
                      }

                    })
                    .catch(function (error) {
                      console.log(error)
                      yo.mostrarNotificacion('Error en el registro', 'BellIcon', error.toString(), 'danger')
                    })

                this.estadoModal = false
              })

            }
          })
    },
    mostrarModal(dni_trabajador, nombres_trabajador, fecha_inicial_date, fecha_final_date, codigo_empresa,promedio_simple) {

      //this.estadoModal = true
      this.infoModal.title = 'Lista de Tareos  - Cumplimiento cuadrilla'
      this.nombres_trabajador = nombres_trabajador
      this.promedio_simples = promedio_simple
      this.loading_c = true
      this.listarDiasTareo(dni_trabajador, nombres_trabajador, fecha_inicial_date, fecha_final_date, codigo_empresa)
    },
    mostrarModalEstadistico( nombres_trabajador, maximo, minimo, desviacion) {

      this.estadoModalEstadistica = true
      this.infoModal.titleEstadistica = 'DATOS ESTADÍSTICOS RANGO'
      this.nombres_trabajador = nombres_trabajador
      this.valor_maximo_rango = maximo + " %"
      this.valor_minimo_rango = minimo + " %"
      this.valor_estandar_rango = desviacion

    },
    mostrarModalAsistenciaHistorico( nombres_trabajador, total, otraslabores, cosecha,falta,dia_empresa) {

      this.estadoModalAsistencia = true
      this.infoModal.titleAsistencia = 'DATOS DE ASISTENCIA HISTORICO'
      this.nombres_trabajador = nombres_trabajador
      this.valor_total_asis = total
      this.valor_otra_labor_asis = otraslabores
      this.valor_cosecha_asis = cosecha
      this.valor_falta_asis = falta
      this.valor_dias_empresa = dia_empresa

    },
    mostrarModalasistenciaRangoText( nombres_trabajador, operativo_rango, canjeado_dias, dias_falta_rango,dias_tareo_rango) {

      let dia_falta_rang = dias_falta_rango;
      if(dia_falta_rang<=0){
        dia_falta_rang = 0;
      }
      this.estadoModalasistenciaRangoText = true
      this.infoModal.titleasistenciaRangoText = 'DATOS DE ASISTENCIA RANGO'
      this.nombres_trabajador = nombres_trabajador
      this.valor_operativo_rango = operativo_rango
      this.valor_canjeado_dias = canjeado_dias
      this.valor_dias_falta_rango = dia_falta_rang
      this.valor_dias_tareo_rango = dias_tareo_rango
    },
    mostrarModalasistenciaRangoTextGlobal( nombres_trabajador, operativo_rango, canjeado_dias, dias_falta_rango,dias_tareo_rango) {

      let dia_falta_rang = dias_falta_rango;
      if(dia_falta_rang<=0){
        dia_falta_rang = 0;
      }
      this.estadoModalasistenciaRangoTextGlobal = true
      this.infoModal.titleasistenciaRangoTextGlobal = 'DATOS DE ASISTENCIA RANGO - ÚLTIMO '+this.ultimoDiaAsistencia + ' DÍAS'
      this.nombres_trabajador = nombres_trabajador
      this.valor_operativo_rango_global = operativo_rango
      this.valor_canjeado_dias_rango_global = canjeado_dias
      this.valor_dias_falta_rango_global = dia_falta_rang
      this.valor_dias_tareo_rango_global = dias_tareo_rango
    },
    listarDiasTareo(dni_trabajador, nombres_trabajador, fecha_inicial_date, fecha_final_date, codigo_empresa) {

      var yo = this

      ///*
      yo.dataGrafico = [];
      if( yo.root != null){
        yo.root.dispose();
      }
      yo.estadoGrafico = true;

      //*/

      // var fecha_inicial_date = "2022-08-22";
      // var fecha_final_date = "2022-08-29";
      // var codigo_empresa = "001";
      // var dni_trabajador = "73880408";
      var body = '' +
          'fecha_inicial=' + fecha_inicial_date + '&' +
          'fecha_final=' + fecha_final_date + '&' +
          'empresa=' + codigo_empresa + '&' +
          'dni_trabajador=' + dni_trabajador
      ''


      var config = {
        method: 'get',
        url: '/cosecha/cosecha/detalleTareo/resumenRatio/ver?' + body
      }

      axiosIns(config)
          .then(function (response) {
            yo.itemsTareos = response.data.response
            yo.totalRowsTareos = yo.itemsTareos.length

            // document.getElementById("contenido").innerText = "";

            //  /*
            for (var i = 0; i <  yo.totalRowsTareos; i++) {
              yo.dataGrafico.push({
                date: new Date(yo.itemsTareos[i]["year"], parseInt(yo.itemsTareos[i]["mes"])-1, yo.itemsTareos[i]["dia"]).getTime(),
                value: parseFloat(yo.itemsTareos[i]["cumplimiento_cuadrilla"]) })
            }


            yo.root = am5.Root.new("contenido");

            yo.root.setThemes([
              am5themes_Animated.new(yo.root)
            ]);

            var chart = yo.root.container.children.push(
                am5xy.XYChart.new(yo.root, {
                  panX: true,
                  panY: true,
                  wheelX: "panX",
                  wheelY: "zoomX"
                })
            );

            var xAxis = chart.xAxes.push(
                am5xy.GaplessDateAxis.new(yo.root, {
                  maxDeviation: 0.1,
                  groupData: false,
                  baseInterval: {
                    timeUnit: "day",
                    count: 1
                  },
                  renderer: am5xy.AxisRendererX.new(yo.root, {
                    minGridDistance: 50
                  }),
                  tooltip: am5.Tooltip.new(yo.root, {})
                })
            );

            var yAxis = chart.yAxes.push(
                am5xy.ValueAxis.new(yo.root, {
                  maxDeviation: 0.1,
                  renderer: am5xy.AxisRendererY.new(yo.root, {})
                })
            );

            var series = chart.series.push(
                am5xy.LineSeries.new(yo.root, {
                  minBulletDistance: 10,
                  xAxis: xAxis,
                  yAxis: yAxis,
                  valueYField: "value",
                  valueXField: "date",
                  tooltip: am5.Tooltip.new(yo.root, {
                    pointerOrientation: "horizontal",
                    labelText: "{valueY}"
                  })
                })
            );

            series.data.setAll(yo.dataGrafico);

            series.bullets.push(function () {
              return am5.Bullet.new(yo.root, {
                sprite: am5.Circle.new(yo.root, {
                  radius: 5,
                  fill: series.get("fill"),
                  stroke: yo.root.interfaceColors.get("background"),
                  strokeWidth: 2
                })
              });
            });

            var cursor = chart.set("cursor", am5xy.XYCursor.new(yo.root, {
              xAxis: xAxis
            }));
            cursor.lineY.set("visible", false);

            chart.set("scrollbarX", am5.Scrollbar.new(yo.root, {
              orientation: "horizontal"
            }));

            series.appear(1000, 100);
            chart.appear(1000, 100);

            // */


          })
          .catch(function (error) {
            console.log(error)
          })
          .finally(function () {
            yo.loading_c = false
            yo.estadoGrafico = false;
          })
    },
    cPaginacion_c(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRowsTareos = filteredItems.length
      this.currentPage_c = 1
    },
    DarDeBaja() {
      var yo = this
      var selecionado = yo.rowSelection.length

      console.log(selecionado);
      var listaTrabajadoresConcatenado = "";

      for (var i = 0;i<yo.rowSelection.length; i++ ){

        listaTrabajadoresConcatenado = listaTrabajadoresConcatenado + "'"+yo.rowSelection[i].toString()+"'";

        console.log(yo.rowSelection[i].toString());
      }
      var listaTrabajadoreBaja = listaTrabajadoresConcatenado.replaceAll("''", "','");




      var icon = 'warning'
      var mensaje = ' dar de baja '
      var trab = ' trabajadores'
      var valorUpdate = '0'
      var mensajeSalida = 'Trabajador dado de baja'

      if (selecionado == 0) {
        yo.$swal.fire(
            'Mensaje',
            'debe seleccionar trabajador',
            'warning'
        )
            .then((result) => {
            })
        return

      }else if (this.existe_excluido == "SI") {
        yo.$swal.fire(
            'Mensaje',
            'seleccionó trabajador excluido',
            'warning'
        )
            .then((result) => {
            })
        return

      } else if (selecionado == 1) {
        trab = ' trabajador'
      }

      this.$swal({
        title: '¡Alerta!',
        text: '¿Seguro que quieres ' + mensaje + ' a ' + selecionado + trab + '?',
        icon: icon,
        showCancelButton: true,
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-danger',
        },
        buttonsStyling: false,
      })
          .then(result => {
            if (result.value) {

              this.$nextTick(() => {

                var yo = this

                yo.show = true
                this.$swal.fire({
                  title: 'Generando...',
                  text: 'Por favor espere, se está guadando los trabajador(es) seleccionados',
                  footer: 'No cierre la ventana',
                  imageUrl: require('@/assets/images/loading/loading.gif'),
                  imageWidth: 200,
                  imageHeight: 200,
                  showCancelButton: false, // There won't be any cancel button
                  showConfirmButton: false // There won't be any confirm button
                })

                var qs = require('qs')
                var data = qs.stringify({
                  'estado_dar_baja': '2',
                  'dni_trabajador': listaTrabajadoreBaja.toString(),
                })

                var config = {
                  method: 'post',
                  url: '/cosecha/cosecha/trabajadorNuevo/anular/all/',
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                  },
                  data: data
                }

                axiosIns(config)
                    .then(function (response) {
                      var res = response.data.respuesta

                      if (res == 'Exitoso') {


                        yo.insertDataDeListaNegra(selecionado, trab)

                      } else {
                        yo.$swal.fire(
                            'Dado de baja!',
                            'No se pudo dar de baja al trabajador(es)!',
                            'info'
                        )
                            .then((result) => {
                            })
                      }

                    })
                    .catch(function (error) {
                      console.log(error)
                      yo.mostrarNotificacion('Error en el registro', 'BellIcon', error.toString(), 'danger')
                    })

              })

            }
          })

    },
    descargarFile_dos() {



      var yo = this
      var datBody =  yo.rowsBajaProductividadInput;
      yo.loading_exp = true;
      var body = '' +
          'p_fecha_corte=' +datBody.p_fecha_corte + '&' +
          'p_fecha_inicial=' +datBody.p_fecha_inicial + '&' +
          'p_fecha_final=' +datBody.p_fecha_final + '&' +
          'p_estado_cosecha=' +datBody.p_estado_cosecha + '&' +
          'p_condicion=' +datBody.p_condicion + '&' +
          'p_aprendizaje_r1_fecha_final=' +datBody.p_aprendizaje_r1_fecha_final + '&' +
          'p_aprendizaje_r2_fecha_inicial=' +datBody.p_aprendizaje_r2_fecha_inicial + '&' +
          'p_categoria_rango=' +datBody.p_categoria_rango + '&' +
          'p_porcentale_cumplimiento_n=' +datBody.p_porcentale_asistencia_n + '&' +
          'p_porcentale_asistencia_n=' +datBody.p_porcentale_asistencia_n + '&' +
          'p_porcentale_aprendizaje_n=' +datBody.p_porcentale_aprendizaje_n + '&' +
          'p_porcentale_cosecha_n=' +datBody.p_porcentale_cosecha_n + '&' +
          'p_porcentale_cumplimiento_a=' +datBody.p_porcentale_cumplimiento_a + '&' +
          'p_porcentale_asistencia_a=' +datBody.p_porcentale_asistencia_a + '&' +
          'p_porcentaje_color_verde=' +datBody.p_porcentaje_color_verde + '&' +
          'p_porcentaje_color_naranja=' +datBody.p_porcentaje_color_naranja + '&' +
          'p_porcentaje_color_rojo=' +datBody.p_porcentaje_color_rojo + '&' +
          'p_fecha_domingo_ultimo_format=' +datBody.p_fecha_domingo_ultimo_format + '&' +
          'p_cumplimiento=' +datBody.p_cumplimiento + '&' +
          'p_regla_cumplimiento=' +datBody.p_regla_cumplimiento + '&' +
          'p_fecha_asisitencia_global='+ datBody.p_fecha_asisitencia_global +
          ''

      var config = {
        method: 'post',
        url: 'https://www.agvperu.com/dms/Jaspergen/exportExcelListaADarBajaTrabajador?'+body,
        headers: { }
      };

      axios(config)
          .then(function (response) {
            if (response.status === 200) {
              yo.loading_exp = true;
              window.location.href = 'https://www.agvperu.com/dms/Jaspergen/downloadExcelJasperListaADarBajaTrabajador';
              yo.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Archivo descargado',
                      icon: 'CheckIcon',
                      text: 'El archivo se descargó satisfactoriamente.',
                      variant: 'success',
                    },
                  },
                  {
                    position: 'top-center',
                  })
              yo.loading_exp = false;
            }
            else if(response.status === 204){

              yo.$toast({
                component: ToastificationContent,
                props: {
                  title: 'No existen registros',
                  icon: 'AlertTriangleIcon',
                  text: 'No se encontraron registros con los parámetros solicitados.',
                  variant: 'warning',
                },
              })
              yo.loading_exp = false;
            }

          })
          .catch(function (error) {
            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error en la creación del archivo',
                icon: 'XIcon',
                text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                variant: 'danger',
              },
            })
            console.log("error1: "+error);
          }).finally(function () {
        yo.loading3 = false
      });
    },
    descargarFile() {
      const yo = this
      const spd = yo.rowsBajaProductividadFiltro
      console.log(spd);

      if (spd.length > 0){
        const data = JSON.stringify(
            {
              "datas":spd,
            }
        )



        const config = {
          method: 'post',
          url: '/cosecha/cosecha/exportar/filter/',
          headers: {
            'Content-Type': 'application/json'
          },
          responseType: 'arraybuffer',
          data : data
        }

        axiosIns(config)
            .then(function (response) {
              console.log(response);

              if (response.status === 200) {

                const fileURL = window.URL.createObjectURL(new Blob([response.data]));
                const fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', "Reporte de baja.xlsx");
                document.body.appendChild(fileLink);
                fileLink.click();



                yo.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'Archivo creado',
                        icon: 'CheckIcon',
                        text: 'El archivo se creó satisfactoriamente.',
                        variant: 'success',
                      },
                    },
                    {
                      position: 'top-center',
                    })
              }
            })
            .catch(function (error) {
              console.log(error);
              yo.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Error en la creación del archivo',
                  icon: 'XIcon',
                  text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                  variant: 'danger',
                },
              })
            })
            .finally(function () {
              yo.loading_exp = false
            });

      }else{
        yo.$toast(
            {
              component: ToastificationContent,
              props: {
                title: '¡Advertencia!',
                icon: 'AlertTriangleIcon',
                text: 'No se encuentran registros para exportar.',
                variant: 'warning',
              },
            },
            {
              position: 'top-center',
            }
        )
      }
    },
    mostrarNotificacion(titulo, icono, texto, variante) {
      this.$toast({
            component: ToastificationContent,
            props: {
              title: titulo,
              icon: icono,
              text: texto,
              variant: variante
            }
          },
          {
            timeout: 5000
          })
    },
    checked(index, checked) {
      if (checked === false) {
      } else {
      }
    },
    selectAll() {
      if (this.selectedItems.length === this.merchants.length) {
        this.selectedItems = []
      } else {
        this.selectedItems = this.merchants.slice()
      }
    },
    rowClass(item, type) {
      return this.selectedItems.indexOf(item) > -1 ? 'table-primary' : ''
    },
    details(item) {
    },

    insertDataDeListaNegra(selecionado, trab) {
      var yo = this
      var data1 = qs.stringify({
        'data_baja': yo.rowObjSelectionData,
      })

      var config1 = {
        method: 'post',
        url: '/cosecha/cosecha/inserta/listaNegra/',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: data1
      }

      axiosIns(config1)
          .then(function (response) {
            yo.show = false
            yo.$swal.fire(
                'Dado de baja!',
                '(' + selecionado + ')' + trab + ' ha sido agregado a la lista negra correctamente',
                'success'
            )
                .then((result) => {
                  yo.validadEntradaRangeFiltro('2','LF')
                })

          })
          .catch(function (error) {
            yo.mostrarNotificacion('Error en el registro', 'BellIcon', error.toString(), 'danger')
            yo.$swal.fire(
                'Dado de baja!',
                'No se pudo dar de baja al trabajador(es)!',
                'info'
            )
                .then((result) => {
                })
          })

    },

    selectionChanged() {
      this.existe_excluido = "";
      this.rowSelection = []
      var rowSelectionData = [];
      const filasSeleccionadas = this.$refs['my-table'].selectedRows
      console.log("Seleccionados:");
      console.log(filasSeleccionadas);
      var table = document.getElementById("my-table").getElementsByTagName("tr");
      filasSeleccionadas.forEach((value, index) => {
        this.rowSelection.push(filasSeleccionadas[index]['dni_trabajador'])
        rowSelectionData.push({
          "codigo_empresa":filasSeleccionadas[index]['codigo_empresa'],
          "dni_trabajador" :filasSeleccionadas[index]['dni_trabajador'],
          "nombres_trabajador":filasSeleccionadas[index]['nombres_trabajador'],
          "fecha_corte_tareo":filasSeleccionadas[index]['fecha_corte_tareo'],
          "fecha_rango_inicial":filasSeleccionadas[index]['fecha_rango_inicial'],
          "fecha_rango_final":filasSeleccionadas[index]['fecha_rango_final'],
          "dia_tareo_rango":filasSeleccionadas[index]['dia_tareo_rango'],
          "promedio_cumplimiento_cuadrilla_rango":filasSeleccionadas[index]['promedio_cumplimiento_cuadrilla_rango'],
          "categoria_rango":filasSeleccionadas[index]['categoria_rango'],
          "total_dia_tareo_historico_corte":filasSeleccionadas[index]['total_dia_tareo_historico_corte'],
          "total_dia_tareo_historico_cosecha_corte":filasSeleccionadas[index]['total_dia_tareo_historico_cosecha_corte'],
          "total_dia_tareo_historico_otra_labores_corte":filasSeleccionadas[index]['total_dia_tareo_historico_otra_labores_corte'],
          "total_dia_falta_historico_corte":filasSeleccionadas[index]['total_falta_rango_asistencia_global'],
          "valor_minimo_rango":filasSeleccionadas[index]['valor_minimo_rango'],
          "valor_maximo_rango":filasSeleccionadas[index]['valor_maximo_rango'],
          "cantidad_muestra_rango":filasSeleccionadas[index]['cantidad_muestra_rango'],
          "valor_desviacion_estandar_muestral_rango":filasSeleccionadas[index]['valor_desviacion_estandar_muestral_rango'],
          "valor_pendiente_rango":filasSeleccionadas[index]['valor_pendiente_rango'],
          "valor_condicion_rango":filasSeleccionadas[index]['valor_condicion_rango'],
          "resultado_condicion_rango":filasSeleccionadas[index]['resultado_condicion_rango'],
          "estado":"1",
          "cantidadd_menor_condicion_rango":filasSeleccionadas[index]['cantidad_menor_condicion_rango'],
          "fecha_start_campaing":filasSeleccionadas[index]['fecha_start_campaing'],
          "fecha_end_campaing":filasSeleccionadas[index]['fecha_end_campaing'],
          "area_gestion": 'COSECHA'
        });
        if (filasSeleccionadas[index]['excluido']=="SI"){
          this.existe_excluido = "SI";
        }
      })

      this.rowObjSelectionData = JSON.stringify(rowSelectionData);

    },

    rowStyleClassFn(row) {
      return row.numero_contratos > 18 ? 'green' : 'red'
    },

    onRowClick(params) {

      /*
     let data = params.row;
     let seleccionado = params.selected;

     let fila_seleccionada =  params.pageIndex;
      var table = document.getElementById("my-table").getElementsByTagName("tr");
      var filaEstilo =  (fila_seleccionada+1);

     // table[2].style.backgroundColor = "yellow";
     // table[filaEstilo].style.backgroundColor = "yellow";
      table[filaEstilo].style.backgroundColor = "yellow";
      if(seleccionado){
       // table[filaEstilo].style.backgroundColor = "yellow";
      }else{
       //table[filaEstilo].style.backgroundColor = "";
      }

      */

    },
    onColumnFilter(params) {
      //Here we need to get recent filter column value only.
      //Api call
    },
    probarfuncion(row, col, cellValue, searchTerm){

    },
    onSearch(params) {
    },
    myFunc(row, col, cellValue, searchTerm){
    },
    handleCustomFilter(value) {
      // filtering logic here
    },
    formatFilterValue(valuesArray) {
      return valuesArray.map((value) => value.dni_trabajador).join(',');
    },

    cerrarModalDiasCosechaRango() {

    },

    filtros2(){
      var palabra = this.filterTable !== null ? this.filterTable.toLowerCase() : ''
      this.rowsBajaProductividadFiltro = this.rowsBajaProductividad
      this.rowsBajaProductividadFiltro = this.rowsBajaProductividadFiltro.filter(
          invoice =>
              (invoice.dni_trabajador.toLowerCase().includes(palabra) || invoice.nombres_trabajador.toLowerCase().includes(palabra)))
      this.totalRows = this.rowsBajaProductividadFiltro.length
    },

    //LUIS

    realizarFiltroCabeceraTable(cabecera, data,condicion){



      console.log("1: " + cabecera);
      console.log("2: " + data);
      console.log("3: " + condicion);
      const yo = this

      if(cabecera === "porcentaje_dia_cosecha"){
        if(yo.cosechaRangoText == ""){
          yo.showAlert("porcentaje_dia_cosecha");
          return;
        }

      }else if(cabecera === "porcentaje_dia_cosecha_historico"){
        if(yo.cosechaHistoricoText == ""){
          yo.showAlert("porcentaje_dia_cosecha_historico");
          return;
        }
      }else if(cabecera === "porcentaje_asistencia_rango"){
        if(yo.asistenciaRangoText == ""){
          yo.showAlert("porcentaje_asistencia_rango");
          return;
        }
      }else if(cabecera === "promedio_aprendizaje"){
        if(yo.mediaAprendizajeRangoText == ""){
          yo.showAlert("promedio_aprendizaje");
          return;
        }
      }
      else if(cabecera === "porcentaje_asistencia_rango_asistencia_global_final"){
        if(yo.diasAsistenciaRangoText == ""){
          yo.showAlert("porcentaje_asistencia_rango_asistencia_global_final");
          return;
        }
      }else if(cabecera === "dias_contrato_rango"){
        if(yo.diasCtoRangoText == ""){
          yo.showAlert("dias_contrato_rango");
          return;
        }
      }else if(cabecera === "total_labores_rango"){
        if(yo.totalTareoRangoText == ""){
          yo.showAlert("total_labores_rango");
          return;
        }
      }else if(cabecera === "total_otras_labores_rango"){
        if(yo.totalOtraLaborRangoText == ""){
          yo.showAlert("total_otras_labores_rango");
          return;
        }
      }else if(cabecera === "nro_dias_cosecha_rango"){
        if(yo.diasCosechaRangoText == ""){
          yo.showAlert("nro_dias_cosecha_rango");
          return;
        }
      }else if(cabecera === "jaba_total_rango"){
        if(yo.jabaTotalRangoText == ""){
          yo.showAlert("jaba_total_rango");
          return;
        }
      }
      else if(cabecera === "resultado_condicion_rango_redondeo"){
        if(yo.resultadoCondicionRangoText == ""){
          yo.showAlert("resultado_condicion_rango_redondeo");
          return;
        }
      }else if(cabecera === "promedio_cumplimiento_cuadrilla_rango_redondeo"){
        if(yo.promedioCumplimientoRangoText == ""){
          yo.showAlert("promedio_cumplimiento_cuadrilla_rango_redondeo");
          return;
        }
      }else if(cabecera === "prom_campania_anterior_rango_redondeo"){
        if(yo.promedioCumplimientoCampAnteriorRangoText == ""){
          yo.showAlert("prom_campania_anterior_rango_redondeo");
          return;
        }
      }else if(cabecera === "promedio_cumplimiento_cuadrilla_rango_redondeo_r1"){
        if(yo.promedioCumplimientoR1RangoText == ""){
          yo.showAlert("promedio_cumplimiento_cuadrilla_rango_redondeo_r1");
          return;
        }
      }else if(cabecera === "promedio_cumplimiento_cuadrilla_rango_redondeo_r2"){
        if(yo.promedioCumplimientoR2RangoText == ""){
          yo.showAlert("promedio_cumplimiento_cuadrilla_rango_redondeo_r2");
          return;
        }
      }else if(cabecera === "calculado"){
        if(yo.calculadoRangoText == ""){
          yo.showAlert("calculado");
          return;
        }
      }





      let dataBajaProdTable_inicial_filtro = yo.rowsBajaProductividad

      let dataFiltradaTable_fase_1 = [];
      let dataFiltradaTable_fase_2 = [];
      let dataFiltradaTable_fase_3 = [];
      let dataFiltradaTable_fase_4 = [];
      let dataFiltradaTable_final_filtro = [];
      // Filtra datos de datos por default

      if(yo.estadoCosechaSelected != "T"){
        dataBajaProdTable_inicial_filtro.forEach(function(value) {
          if (value["estado_cosecha"].toString() === yo.estadoCosechaSelected.toString()){
            dataFiltradaTable_fase_1.push(value);          }
        });
      }else{
        dataFiltradaTable_fase_1 = dataBajaProdTable_inicial_filtro;
      }
      //
      var categorias = ["MALOS 2","MALOS 1","REGULARES 2","REGULARES 1","BUENOS","MUY BUENOS","TOP WORKERS"]
      var seleccionoTodos = false;
      for(const values of yo.categoriaSelected){
        if(values=="TODOS"){
          seleccionoTodos = true;
        }
      }
      if(seleccionoTodos==false){
        categorias = yo.categoriaSelected;
      }
      for(const values of categorias){

        dataFiltradaTable_fase_1.forEach(function(value) {
          if(value["categoria_rango"].toString() === values.toString()){
           // alert(value)
            dataFiltradaTable_fase_2.push(value)
          }
        });
      };
      //promedio_cumplimiento_cuadrilla_rango
      //
      dataFiltradaTable_fase_2.forEach(function(value) {
        if(yo.operadorSelected == ">="){
          if(value["promedio_cumplimiento_cuadrilla_rango"] >= yo.cumplimientoText){
            dataFiltradaTable_fase_3.push(value)
          }
        }else if(yo.operadorSelected == "<="){
          if(value["promedio_cumplimiento_cuadrilla_rango"] <= yo.cumplimientoText){
            dataFiltradaTable_fase_3.push(value)
          }
        }else if(yo.operadorSelected == "=="){
          if(value["promedio_cumplimiento_cuadrilla_rango"] == yo.cumplimientoText){
            dataFiltradaTable_fase_3.push(value)
          }
        }
      });
      //



      //Filtra datos de las columnas
      let c = 0
      for(const valor of yo.filtroCabeceraTable){
        if (valor.nombre === cabecera){
          yo.filtroCabeceraTable[c].valor = data
          yo.filtroCabeceraTable[c].condicional = condicion

        }
        c += 1;
      }

      var tipo = "";
      var condicional = "";




      for(const values of yo.filtroCabeceraTable){
        tipo =  values.tipo;
        condicional = values.condicional;

        if(values.valor == 0){
          dataBajaProdTable_inicial_filtro = dataFiltradaTable_fase_3;
          dataFiltradaTable_final_filtro = []
        }
        for ( const column of values.valor ){

          console.log("7: "+column);
          dataFiltradaTable_fase_3.forEach(function(value) {

            if (column === 'VACIOS') {
              if (value[values.nombre] === null || value[values.nombre] === '' || value[values.nombre] === ' ' || value[values.nombre] === '  '){
                dataFiltradaTable_final_filtro.push(value)
              }
            }else{

              if(tipo == "string"){
                console.log("8: "+column.toString());
                if (value[values.nombre].toString() === column.toString()){
                  dataFiltradaTable_final_filtro.push(value)
                }
              }else{
                if(condicional === "="){
                  if (value[values.nombre].toString() === column.toString()){
                    dataFiltradaTable_final_filtro.push(value)
                  }
                }else if(condicional === ">="){
                  if (value[values.nombre] >= column){
                    dataFiltradaTable_final_filtro.push(value)
                  }
                }else {
                  if (value[values.nombre] <= column){
                    dataFiltradaTable_final_filtro.push(value)
                  }
                }

              }

            }
          })
        }


        if(values.valor.length > 0){
          dataFiltradaTable_fase_3 = dataFiltradaTable_final_filtro
          dataFiltradaTable_final_filtro = []
        }
      }

      yo.rowsBajaProductividadFiltro = dataFiltradaTable_fase_3

      if(data.length<=0){
        if(cabecera ==="porcentaje_dia_cosecha"){
          this.condicionalSelectedCosRango = "=";
          this.cosechaRangoText = "";
        }else if(cabecera ==="porcentaje_dia_cosecha_historico"){
          this.cosechaHistoricoText = "";
          this.condicionalSelectedCosHistorico = "=";
        }else if(cabecera ==="porcentaje_asistencia_rango"){
          this.asistenciaRangoText = "";
          this.condicionalSelectedAsistencia = "=";
        } else if(cabecera ==="promedio_aprendizaje"){
          this.mediaAprendizajeRangoText = "";
          this.condicionalSelectedMediaAprendizaje = "=";
        }
        else if(cabecera ==="porcentaje_asistencia_rango_asistencia_global_final"){
          this.diasAsistenciaRangoText = "";
          this.condicionalSelectedDiasAsistencia = "=";
        }else if(cabecera ==="dias_contrato_rango"){
          this.totalTareoRangoText = "";
          this.condicionalSelectedDiasCtoRango = "=";
        }else if(cabecera ==="total_labores_rango"){
          this.totalTareoRangoText = "";
          this.condicionalSelectedtotalTareoRango = "=";
        }else if(cabecera ==="total_otras_labores_rango"){
          this.totalOtraLaborRangoText = "";
          this.condicionalSelectedtotalOtraLaborRango = "=";
        }else if(cabecera ==="nro_dias_cosecha_rango"){
          this.diasCosechaRangoText = "";
          this.condicionalSelecteddiasCosechaRango = "=";
        }else if(cabecera ==="jaba_total_rango"){
          this.jabaTotalRangoText = "";
          this.condicionalSelectedjabaTotalRango = "=";
        }else if(cabecera ==="resultado_condicion_rango_redondeo"){
          this.resultadoCondicionRangoText = "";
          this.condicionalSelectedresultadoCondicionRango = "=";
        }else if(cabecera ==="promedio_cumplimiento_cuadrilla_rango_redondeo"){
          this.promedioCumplimientoRangoText = "";
          this.condicionalSelectedpromedioCumplimientoRango = "=";
        }else if(cabecera ==="prom_campania_anterior_rango_redondeo"){
          this.promedioCumplimientoCampAnteriorRangoText = "";
          this.condicionalSelectedpromedioCumplimientoCampAnteriorRango = "=";
        }else if(cabecera ==="promedio_cumplimiento_cuadrilla_rango_redondeo_r1"){
          this.promedioCumplimientoR1RangoText = "";
          this.condicionalSelectedpromedioCumplimientoR1Rango = "=";
        }else if(cabecera ==="promedio_cumplimiento_cuadrilla_rango_redondeo_r2"){
          this.promedioCumplimientoR2RangoText = "";
          this.condicionalSelectedpromedioCumplimientoR2Rango = "=";
        }else if(cabecera ==="calculado"){
          this.calculadoRangoText = "";
          this.condicionalSelectedcalculadoRango = "=";
        }
      }





    },

    ordenarFieldsCabeceraTable(field, tipo){
      this.sortByTable = field.toString()
      this.sortAscDesc = tipo.toString()
    },

    cancelarOrdenacionCabeceraTable(field){
      this.sortByTable = 'nombres_trabajador'
      this.sortAscDesc = 'acs'
    },

    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    countDownChangedCosRango(dismissCountDown) {
      this.dismissCountDownCosRango = dismissCountDown
    },
    countDownChangedCosHistorico(dismissCountDown) {
      this.dismissCountDownCosHistorico = dismissCountDown
    },
    showAlert(cabecera) {

      if(cabecera === "porcentaje_dia_cosecha"){
        this.dismissCountDownCosRango = this.dismissSecsCosRango;
      }else if(cabecera === "porcentaje_dia_cosecha_historico"){
        this.dismissCountDownCosHistorico = this.dismissSecsCosHistorico ;
      }else if(cabecera === "porcentaje_asistencia_rango"){
        this.dismissCountDown = this.dismissSecs;
      }else if(cabecera === "promedio_aprendizaje"){
        this.dismissCountDownMediaAprendizaje = this.dismissSecsMediaAprendizaje;
      }else if(cabecera === "porcentaje_asistencia_rango_asistencia_global_final"){
        this.dismissCountDownDiasAsistencia = this.dismissSecsDiasAsistencia;
      }else if(cabecera === "dias_contrato_rango"){
        this.dismissCountDownDiasCtoRango= this.dismissSecsDiasCtoRango;
      }else if(cabecera === "total_labores_rango"){
        this.dismissCountDownTotalTareoRango= this.dismissSecsTotalTareoRango;
      }else if(cabecera === "total_otras_labores_rango"){
        this.dismissCountDowntotalOtraLaborRango= this.dismissSecstotalOtraLaborRango;
      }else if(cabecera === "nro_dias_cosecha_rango"){
        this.dismissCountDowndiasCosechaRango= this.dismissSecsdiasCosechaRango;
      }else if(cabecera === "jaba_total_rango"){
        this.dismissCountDownjabaTotalRango= this.dismissSecsjabaTotalRango;
      }else if(cabecera === "resultado_condicion_rango_redondeo"){
        this.dismissCountDownresultadoCondicionRango = this.dismissCountDownresultadoCondicionRango;
      }else if(cabecera === "promedio_cumplimiento_cuadrilla_rango_redondeo"){
        this.dismissCountDownpromedioCumplimientoRango = this.dismissSecspromedioCumplimientoRango;
      }else if(cabecera === "prom_campania_anterior_rango_redondeo") {
        this.dismissCountDownpromedioCumplimientoCampAnteriorRango = this.dismissSecspromedioCumplimientoCampAnteriorRango;
      }else if(cabecera === "promedio_cumplimiento_cuadrilla_rango_redondeo_r1"){
        this.dismissCountDownpromedioCumplimientoR1Rango = this.dismissSecspromedioCumplimientoR1Rango;
      }else if(cabecera === "promedio_cumplimiento_cuadrilla_rango_redondeo_r2"){
        this.dismissCountDownpromedioCumplimientoR2Rango = this.dismissSecspromedioCumplimientoR2Rango;
      }else if(cabecera === "calculado"){
        this.dismissCountDowncalculadoRango = this.dismissSecscalculadoRango;
      }
    },
    onRowMouseleave(row, pageIndex) {
      // row - row object
      // pageIndex - index of this row on the current page.
    },


    onRowDoubleClick(params) {
      let yo = this;
      let filaSeleced = params.pageIndex;
      let estadoFilaSeleced = params.selected;



      //params.selected
      //this.$set(params.row, 'active', !params.row.active);
    },
    onPageChange(params) {
      let paguina = params.currentPage;
      this.numeroPaguinaActual = paguina;
      // params.currentPage - current page that pagination is at
      // params.prevPage - previous page
      // params.currentPerPage - number of items per page
      // params.total - total number of items in the table
    },
    verResumenCategoria(fechaInicioRange, fechaFinRange, fecha_corte_seleccionada){
      var yo = this
      yo.estadoModalResumenCategoria = true;
      yo.infoModal.titleResumenCategoria = 'Resumen de personal';
      yo.loading_res = true;
      yo.total_personal_categ = 0;
      yo.total_personal_nuevo = 0;
      yo.total_personal_antiguo = 0;
      yo.total_personal_total_porcentaje = 0;
      var fechaInArr = fechaInicioRange.split('-');
      var fechaFiArr = fechaFinRange.split('-');
      yo.rango_fecha_resumen = fechaInArr[2]+'/'+ fechaInArr[1]+'/'+fechaInArr[0]+' al ' + fechaFiArr[2]+'/'+ fechaFiArr[1]+'/'+fechaFiArr[0];

      var body = '' +
          'fecha_inicial=' + fechaInicioRange + '&' +
          'fecha_final=' + fechaFinRange + '&' +
          'fecha_corte=' + fecha_corte_seleccionada
      ''

      var config = {
        method: 'get',
        url: '/cosecha/cosecha/getResumenCategorias/?' + body,
        headers: {}
      }

      axiosIns(config)
          .then((response) => {
            yo.itemsResumen = response.data.respuesta;
            var total = 0;
            var nuevo = 0;
            var antiguo = 0;
            for (let value of  yo.itemsResumen){
              if (value.total != null && value.total !== '' && value.total !== ' ' && value.total !== '  ')
              {
                total = total + value.total;
              }
              if (value.nuevos != null && value.nuevos !== '' && value.nuevos !== ' ' && value.nuevos !== '  ')
              {
                nuevo = nuevo + value.nuevos;
              }
              if (value.antiguos != null && value.antiguos !== '' && value.antiguos !== ' ' && value.antiguos !== '  ')
              {
                antiguo = antiguo + value.antiguos;
              }
            }
            yo.total_personal_categ = total;
            yo.total_personal_nuevo = nuevo;
            yo.total_personal_antiguo = antiguo;
            yo.total_personal_total_porcentaje = (yo.total_personal_categ/yo.total_personal_categ)*100;
          })
          .catch(function (error) {
            console.log(error)
          })
          .finally(function () {
            yo.loading_res = false
          })

    },

  },
}
</script>

<style lang="scss">

@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-good-table.scss';


.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: 'Seleccionar';
}

.alinear-medio{
  vertical-align: middle!important;
}

.alinear-una-sola-linea{
  white-space: nowrap!important;
}

.color-naviera{
  font-weight: 900!important;
}

.gradiente{
  background-color: rgba(175, 227, 250, 0.5) !important;
  transition: all 0.2s ease!important;
  background-repeat: repeat!important;
}


.repetido{
  background-color: rgba(250, 175, 175, 0.55) !important;
  transition: all 0.2s ease!important;
  /*color: #ffffff !important;*/
  background-repeat: repeat!important;
}

.cancelados{
  background-color: rgba(255, 255, 0, 0.55) !important;
  transition: all 0.2s ease!important;
  /*color: #ffffff !important;*/
  background-repeat: repeat!important;
}

.tenue-naranja{
  background-color: rgba(251, 168, 32, 0.08);
}

.tenue-verde{
  background-color: rgba(40, 199, 111, 0.08);
}

.tenue-rojo{
  background-color: rgba(199, 40, 40, 0.08);
}

.tenue-amarillo{
  background-color: rgba(204, 190, 41, 0.1);
}

.b-table-row-selected {
  color: #555555 !important;
  font-weight: bold!important;
}

.alinear-present{
  min-width: 330px!important;
}

.customizer-section {
  padding: 1rem 1rem 0.8rem 1rem;
  border-bottom: 1px solid #ebe9f1;

  .dark-layout & {
    border-color: $theme-dark-border-color;
  }

  #skin-radio-group ::v-deep {
    .custom-control-inline {
      margin-right: 0.7rem;
    }
  }

  .form-group {
    margin-bottom: 1.5rem;;
    &:last-of-type {
      margin-bottom: 0;
    }
    ::v-deep legend {
      font-weight: 500;
    }
  }
}

.mark-active {
  box-shadow: 0 0 0 0.2rem rgba(38,143,255,.5);
}

.ps-customizer-area {
  height: calc(100% - 105px)
}

.tablita{
  min-height: 58vh!important;
  display:inline-block;
  position: relative;

}
.table-format {
  border: 2px solid #ebe9f1;
  border-collapse: collapse;
  cursor:pointer; cursor: hand;
}

.table-format th{
  border-bottom: solid 1px #ebe9f1;
  padding: 15px;
  text-align: left;
  //  background-color: rgba(243, 242, 247, 1);
  border-bottom: solid 2px #ebe9f1;
}

.table-format th:nth-child(1){
  border-bottom: solid 1px #ebe9f1;
  // position: fixed;
  // border-bottom: solid 1px #ebe9f1;
}

.table-format td{
  font-family: Montserrat,Arial, Helvetica, SansSerif;
  padding: 15px;
  caption-side: bottom;
  text-align: left;
  border-bottom: solid 1px #ebe9f1;
}


.table-format tbody tr:hover {
  background-color:rgba(246, 246, 249, 1);
  font-weight: bold;
  // font-size: 13px;

  .fila-seleccionada {
    background-color: red;
  }

}




.dropdown-toggle::after {
  background-image: none;
}



</style>
<style scoped>
.hello {
  width: 100%;
  height: 300px;
}
</style>

